function mt(i, e, t) {
  for (let n = 0; ; n++) {
    if (n == i.childCount || n == e.childCount)
      return i.childCount == e.childCount ? null : t;
    let r = i.child(n), s = e.child(n);
    if (r == s) {
      t += r.nodeSize;
      continue;
    }
    if (!r.sameMarkup(s))
      return t;
    if (r.isText && r.text != s.text) {
      for (let o = 0; r.text[o] == s.text[o]; o++)
        t++;
      return t;
    }
    if (r.content.size || s.content.size) {
      let o = mt(r.content, s.content, t + 1);
      if (o != null)
        return o;
    }
    t += r.nodeSize;
  }
}
function gt(i, e, t, n) {
  for (let r = i.childCount, s = e.childCount; ; ) {
    if (r == 0 || s == 0)
      return r == s ? null : { a: t, b: n };
    let o = i.child(--r), l = e.child(--s), a = o.nodeSize;
    if (o == l) {
      t -= a, n -= a;
      continue;
    }
    if (!o.sameMarkup(l))
      return { a: t, b: n };
    if (o.isText && o.text != l.text) {
      let c = 0, f = Math.min(o.text.length, l.text.length);
      for (; c < f && o.text[o.text.length - c - 1] == l.text[l.text.length - c - 1]; )
        c++, t--, n--;
      return { a: t, b: n };
    }
    if (o.content.size || l.content.size) {
      let c = gt(o.content, l.content, t - 1, n - 1);
      if (c)
        return c;
    }
    t -= a, n -= a;
  }
}
class g {
  constructor(e, t) {
    if (this.content = e, this.size = t || 0, t == null)
      for (let n = 0; n < e.length; n++)
        this.size += e[n].nodeSize;
  }
  nodesBetween(e, t, n, r = 0, s) {
    for (let o = 0, l = 0; l < t; o++) {
      let a = this.content[o], c = l + a.nodeSize;
      if (c > e && n(a, r + l, s || null, o) !== !1 && a.content.size) {
        let f = l + 1;
        a.nodesBetween(Math.max(0, e - f), Math.min(a.content.size, t - f), n, r + f);
      }
      l = c;
    }
  }
  descendants(e) {
    this.nodesBetween(0, this.size, e);
  }
  textBetween(e, t, n, r) {
    let s = "", o = !0;
    return this.nodesBetween(e, t, (l, a) => {
      l.isText ? (s += l.text.slice(Math.max(e, a) - a, t - a), o = !n) : l.isLeaf ? (r ? s += typeof r == "function" ? r(l) : r : l.type.spec.leafText && (s += l.type.spec.leafText(l)), o = !n) : !o && l.isBlock && (s += n, o = !0);
    }, 0), s;
  }
  append(e) {
    if (!e.size)
      return this;
    if (!this.size)
      return e;
    let t = this.lastChild, n = e.firstChild, r = this.content.slice(), s = 0;
    for (t.isText && t.sameMarkup(n) && (r[r.length - 1] = t.withText(t.text + n.text), s = 1); s < e.content.length; s++)
      r.push(e.content[s]);
    return new g(r, this.size + e.size);
  }
  cut(e, t = this.size) {
    if (e == 0 && t == this.size)
      return this;
    let n = [], r = 0;
    if (t > e)
      for (let s = 0, o = 0; o < t; s++) {
        let l = this.content[s], a = o + l.nodeSize;
        a > e && ((o < e || a > t) && (l.isText ? l = l.cut(Math.max(0, e - o), Math.min(l.text.length, t - o)) : l = l.cut(Math.max(0, e - o - 1), Math.min(l.content.size, t - o - 1))), n.push(l), r += l.nodeSize), o = a;
      }
    return new g(n, r);
  }
  cutByIndex(e, t) {
    return e == t ? g.empty : e == 0 && t == this.content.length ? this : new g(this.content.slice(e, t));
  }
  replaceChild(e, t) {
    let n = this.content[e];
    if (n == t)
      return this;
    let r = this.content.slice(), s = this.size + t.nodeSize - n.nodeSize;
    return r[e] = t, new g(r, s);
  }
  addToStart(e) {
    return new g([e].concat(this.content), this.size + e.nodeSize);
  }
  addToEnd(e) {
    return new g(this.content.concat(e), this.size + e.nodeSize);
  }
  eq(e) {
    if (this.content.length != e.content.length)
      return !1;
    for (let t = 0; t < this.content.length; t++)
      if (!this.content[t].eq(e.content[t]))
        return !1;
    return !0;
  }
  get firstChild() {
    return this.content.length ? this.content[0] : null;
  }
  get lastChild() {
    return this.content.length ? this.content[this.content.length - 1] : null;
  }
  get childCount() {
    return this.content.length;
  }
  child(e) {
    let t = this.content[e];
    if (!t)
      throw new RangeError("Index " + e + " out of range for " + this);
    return t;
  }
  maybeChild(e) {
    return this.content[e] || null;
  }
  forEach(e) {
    for (let t = 0, n = 0; t < this.content.length; t++) {
      let r = this.content[t];
      e(r, n, t), n += r.nodeSize;
    }
  }
  findDiffStart(e, t = 0) {
    return mt(this, e, t);
  }
  findDiffEnd(e, t = this.size, n = e.size) {
    return gt(this, e, t, n);
  }
  findIndex(e, t = -1) {
    if (e == 0)
      return ce(0, e);
    if (e == this.size)
      return ce(this.content.length, e);
    if (e > this.size || e < 0)
      throw new RangeError(`Position ${e} outside of fragment (${this})`);
    for (let n = 0, r = 0; ; n++) {
      let s = this.child(n), o = r + s.nodeSize;
      if (o >= e)
        return o == e || t > 0 ? ce(n + 1, o) : ce(n, r);
      r = o;
    }
  }
  toString() {
    return "<" + this.toStringInner() + ">";
  }
  toStringInner() {
    return this.content.join(", ");
  }
  toJSON() {
    return this.content.length ? this.content.map((e) => e.toJSON()) : null;
  }
  static fromJSON(e, t) {
    if (!t)
      return g.empty;
    if (!Array.isArray(t))
      throw new RangeError("Invalid input for Fragment.fromJSON");
    return new g(t.map(e.nodeFromJSON));
  }
  static fromArray(e) {
    if (!e.length)
      return g.empty;
    let t, n = 0;
    for (let r = 0; r < e.length; r++) {
      let s = e[r];
      n += s.nodeSize, r && s.isText && e[r - 1].sameMarkup(s) ? (t || (t = e.slice(0, r)), t[t.length - 1] = s.withText(t[t.length - 1].text + s.text)) : t && t.push(s);
    }
    return new g(t || e, n);
  }
  static from(e) {
    if (!e)
      return g.empty;
    if (e instanceof g)
      return e;
    if (Array.isArray(e))
      return this.fromArray(e);
    if (e.attrs)
      return new g([e], e.nodeSize);
    throw new RangeError("Can not convert " + e + " to a Fragment" + (e.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
  }
}
g.empty = new g([], 0);
const Me = { index: 0, offset: 0 };
function ce(i, e) {
  return Me.index = i, Me.offset = e, Me;
}
function Re(i, e) {
  if (i === e)
    return !0;
  if (!(i && typeof i == "object") || !(e && typeof e == "object"))
    return !1;
  let t = Array.isArray(i);
  if (Array.isArray(e) != t)
    return !1;
  if (t) {
    if (i.length != e.length)
      return !1;
    for (let n = 0; n < i.length; n++)
      if (!Re(i[n], e[n]))
        return !1;
  } else {
    for (let n in i)
      if (!(n in e) || !Re(i[n], e[n]))
        return !1;
    for (let n in e)
      if (!(n in i))
        return !1;
  }
  return !0;
}
class O {
  constructor(e, t) {
    this.type = e, this.attrs = t;
  }
  addToSet(e) {
    let t, n = !1;
    for (let r = 0; r < e.length; r++) {
      let s = e[r];
      if (this.eq(s))
        return e;
      if (this.type.excludes(s.type))
        t || (t = e.slice(0, r));
      else {
        if (s.type.excludes(this.type))
          return e;
        !n && s.type.rank > this.type.rank && (t || (t = e.slice(0, r)), t.push(this), n = !0), t && t.push(s);
      }
    }
    return t || (t = e.slice()), n || t.push(this), t;
  }
  removeFromSet(e) {
    for (let t = 0; t < e.length; t++)
      if (this.eq(e[t]))
        return e.slice(0, t).concat(e.slice(t + 1));
    return e;
  }
  isInSet(e) {
    for (let t = 0; t < e.length; t++)
      if (this.eq(e[t]))
        return !0;
    return !1;
  }
  eq(e) {
    return this == e || this.type == e.type && Re(this.attrs, e.attrs);
  }
  toJSON() {
    let e = { type: this.type.name };
    for (let t in this.attrs) {
      e.attrs = this.attrs;
      break;
    }
    return e;
  }
  static fromJSON(e, t) {
    if (!t)
      throw new RangeError("Invalid input for Mark.fromJSON");
    let n = e.marks[t.type];
    if (!n)
      throw new RangeError(`There is no mark type ${t.type} in this schema`);
    return n.create(t.attrs);
  }
  static sameSet(e, t) {
    if (e == t)
      return !0;
    if (e.length != t.length)
      return !1;
    for (let n = 0; n < e.length; n++)
      if (!e[n].eq(t[n]))
        return !1;
    return !0;
  }
  static setFrom(e) {
    if (!e || Array.isArray(e) && e.length == 0)
      return O.none;
    if (e instanceof O)
      return [e];
    let t = e.slice();
    return t.sort((n, r) => n.type.rank - r.type.rank), t;
  }
}
O.none = [];
class yt extends Error {
}
class y {
  constructor(e, t, n) {
    this.content = e, this.openStart = t, this.openEnd = n;
  }
  get size() {
    return this.content.size - this.openStart - this.openEnd;
  }
  insertAt(e, t) {
    let n = kt(this.content, e + this.openStart, t);
    return n && new y(n, this.openStart, this.openEnd);
  }
  removeBetween(e, t) {
    return new y(wt(this.content, e + this.openStart, t + this.openStart), this.openStart, this.openEnd);
  }
  eq(e) {
    return this.content.eq(e.content) && this.openStart == e.openStart && this.openEnd == e.openEnd;
  }
  toString() {
    return this.content + "(" + this.openStart + "," + this.openEnd + ")";
  }
  toJSON() {
    if (!this.content.size)
      return null;
    let e = { content: this.content.toJSON() };
    return this.openStart > 0 && (e.openStart = this.openStart), this.openEnd > 0 && (e.openEnd = this.openEnd), e;
  }
  static fromJSON(e, t) {
    if (!t)
      return y.empty;
    let n = t.openStart || 0, r = t.openEnd || 0;
    if (typeof n != "number" || typeof r != "number")
      throw new RangeError("Invalid input for Slice.fromJSON");
    return new y(g.fromJSON(e, t.content), n, r);
  }
  static maxOpen(e, t = !0) {
    let n = 0, r = 0;
    for (let s = e.firstChild; s && !s.isLeaf && (t || !s.type.spec.isolating); s = s.firstChild)
      n++;
    for (let s = e.lastChild; s && !s.isLeaf && (t || !s.type.spec.isolating); s = s.lastChild)
      r++;
    return new y(e, n, r);
  }
}
y.empty = new y(g.empty, 0, 0);
function wt(i, e, t) {
  let { index: n, offset: r } = i.findIndex(e), s = i.maybeChild(n), { index: o, offset: l } = i.findIndex(t);
  if (r == e || s.isText) {
    if (l != t && !i.child(o).isText)
      throw new RangeError("Removing non-flat range");
    return i.cut(0, e).append(i.cut(t));
  }
  if (n != o)
    throw new RangeError("Removing non-flat range");
  return i.replaceChild(n, s.copy(wt(s.content, e - r - 1, t - r - 1)));
}
function kt(i, e, t, n) {
  let { index: r, offset: s } = i.findIndex(e), o = i.maybeChild(r);
  if (s == e || o.isText)
    return n && !n.canReplace(r, r, t) ? null : i.cut(0, e).append(t).append(i.cut(e));
  let l = kt(o.content, e - s - 1, t);
  return l && i.replaceChild(r, o.copy(l));
}
class ze {
  constructor(e, t, n) {
    this.$from = e, this.$to = t, this.depth = n;
  }
  get start() {
    return this.$from.before(this.depth + 1);
  }
  get end() {
    return this.$to.after(this.depth + 1);
  }
  get parent() {
    return this.$from.node(this.depth);
  }
  get startIndex() {
    return this.$from.index(this.depth);
  }
  get endIndex() {
    return this.$to.indexAfter(this.depth);
  }
}
class ge {
  constructor(e, t) {
    this.schema = e, this.rules = t, this.tags = [], this.styles = [], t.forEach((n) => {
      n.tag ? this.tags.push(n) : n.style && this.styles.push(n);
    }), this.normalizeLists = !this.tags.some((n) => {
      if (!/^(ul|ol)\b/.test(n.tag) || !n.node)
        return !1;
      let r = e.nodes[n.node];
      return r.contentMatch.matchType(r);
    });
  }
  parse(e, t = {}) {
    let n = new Qe(this, t, !1);
    return n.addAll(e, t.from, t.to), n.finish();
  }
  parseSlice(e, t = {}) {
    let n = new Qe(this, t, !0);
    return n.addAll(e, t.from, t.to), y.maxOpen(n.finish());
  }
  matchTag(e, t, n) {
    for (let r = n ? this.tags.indexOf(n) + 1 : 0; r < this.tags.length; r++) {
      let s = this.tags[r];
      if (nn(e, s.tag) && (s.namespace === void 0 || e.namespaceURI == s.namespace) && (!s.context || t.matchesContext(s.context))) {
        if (s.getAttrs) {
          let o = s.getAttrs(e);
          if (o === !1)
            continue;
          s.attrs = o || void 0;
        }
        return s;
      }
    }
  }
  matchStyle(e, t, n, r) {
    for (let s = r ? this.styles.indexOf(r) + 1 : 0; s < this.styles.length; s++) {
      let o = this.styles[s], l = o.style;
      if (!(l.indexOf(e) != 0 || o.context && !n.matchesContext(o.context) || l.length > e.length && (l.charCodeAt(e.length) != 61 || l.slice(e.length + 1) != t))) {
        if (o.getAttrs) {
          let a = o.getAttrs(t);
          if (a === !1)
            continue;
          o.attrs = a || void 0;
        }
        return o;
      }
    }
  }
  static schemaRules(e) {
    let t = [];
    function n(r) {
      let s = r.priority == null ? 50 : r.priority, o = 0;
      for (; o < t.length; o++) {
        let l = t[o];
        if ((l.priority == null ? 50 : l.priority) < s)
          break;
      }
      t.splice(o, 0, r);
    }
    for (let r in e.marks) {
      let s = e.marks[r].spec.parseDOM;
      s && s.forEach((o) => {
        n(o = Xe(o)), o.mark = r;
      });
    }
    for (let r in e.nodes) {
      let s = e.nodes[r].spec.parseDOM;
      s && s.forEach((o) => {
        n(o = Xe(o)), o.node = r;
      });
    }
    return t;
  }
  static fromSchema(e) {
    return e.cached.domParser || (e.cached.domParser = new ge(e, ge.schemaRules(e)));
  }
}
const St = {
  address: !0,
  article: !0,
  aside: !0,
  blockquote: !0,
  canvas: !0,
  dd: !0,
  div: !0,
  dl: !0,
  fieldset: !0,
  figcaption: !0,
  figure: !0,
  footer: !0,
  form: !0,
  h1: !0,
  h2: !0,
  h3: !0,
  h4: !0,
  h5: !0,
  h6: !0,
  header: !0,
  hgroup: !0,
  hr: !0,
  li: !0,
  noscript: !0,
  ol: !0,
  output: !0,
  p: !0,
  pre: !0,
  section: !0,
  table: !0,
  tfoot: !0,
  ul: !0
}, en = {
  head: !0,
  noscript: !0,
  object: !0,
  script: !0,
  style: !0,
  title: !0
}, xt = { ol: !0, ul: !0 }, ye = 1, we = 2, Y = 4;
function Ue(i, e, t) {
  return e != null ? (e ? ye : 0) | (e === "full" ? we : 0) : i && i.whitespace == "pre" ? ye | we : t & ~Y;
}
class fe {
  constructor(e, t, n, r, s, o, l) {
    this.type = e, this.attrs = t, this.marks = n, this.pendingMarks = r, this.solid = s, this.options = l, this.content = [], this.activeMarks = O.none, this.stashMarks = [], this.match = o || (l & Y ? null : e.contentMatch);
  }
  findWrapping(e) {
    if (!this.match) {
      if (!this.type)
        return [];
      let t = this.type.contentMatch.fillBefore(g.from(e));
      if (t)
        this.match = this.type.contentMatch.matchFragment(t);
      else {
        let n = this.type.contentMatch, r;
        return (r = n.findWrapping(e.type)) ? (this.match = n, r) : null;
      }
    }
    return this.match.findWrapping(e.type);
  }
  finish(e) {
    if (!(this.options & ye)) {
      let n = this.content[this.content.length - 1], r;
      if (n && n.isText && (r = /[ \t\r\n\u000c]+$/.exec(n.text))) {
        let s = n;
        n.text.length == r[0].length ? this.content.pop() : this.content[this.content.length - 1] = s.withText(s.text.slice(0, s.text.length - r[0].length));
      }
    }
    let t = g.from(this.content);
    return !e && this.match && (t = t.append(this.match.fillBefore(g.empty, !0))), this.type ? this.type.create(this.attrs, t, this.marks) : t;
  }
  popFromStashMark(e) {
    for (let t = this.stashMarks.length - 1; t >= 0; t--)
      if (e.eq(this.stashMarks[t]))
        return this.stashMarks.splice(t, 1)[0];
  }
  applyPending(e) {
    for (let t = 0, n = this.pendingMarks; t < n.length; t++) {
      let r = n[t];
      (this.type ? this.type.allowsMarkType(r.type) : sn(r.type, e)) && !r.isInSet(this.activeMarks) && (this.activeMarks = r.addToSet(this.activeMarks), this.pendingMarks = r.removeFromSet(this.pendingMarks));
    }
  }
  inlineContext(e) {
    return this.type ? this.type.inlineContent : this.content.length ? this.content[0].isInline : e.parentNode && !St.hasOwnProperty(e.parentNode.nodeName.toLowerCase());
  }
}
class Qe {
  constructor(e, t, n) {
    this.parser = e, this.options = t, this.isOpen = n, this.open = 0;
    let r = t.topNode, s, o = Ue(null, t.preserveWhitespace, 0) | (n ? Y : 0);
    r ? s = new fe(r.type, r.attrs, O.none, O.none, !0, t.topMatch || r.type.contentMatch, o) : n ? s = new fe(null, null, O.none, O.none, !0, null, o) : s = new fe(e.schema.topNodeType, null, O.none, O.none, !0, null, o), this.nodes = [s], this.find = t.findPositions, this.needsBlock = !1;
  }
  get top() {
    return this.nodes[this.open];
  }
  addDOM(e) {
    if (e.nodeType == 3)
      this.addTextNode(e);
    else if (e.nodeType == 1) {
      let t = e.getAttribute("style"), n = t ? this.readStyles(rn(t)) : null, r = this.top;
      if (n != null)
        for (let s = 0; s < n.length; s++)
          this.addPendingMark(n[s]);
      if (this.addElement(e), n != null)
        for (let s = 0; s < n.length; s++)
          this.removePendingMark(n[s], r);
    }
  }
  addTextNode(e) {
    let t = e.nodeValue, n = this.top;
    if (n.options & we || n.inlineContext(e) || /[^ \t\r\n\u000c]/.test(t)) {
      if (n.options & ye)
        n.options & we ? t = t.replace(/\r\n?/g, `
`) : t = t.replace(/\r?\n|\r/g, " ");
      else if (t = t.replace(/[ \t\r\n\u000c]+/g, " "), /^[ \t\r\n\u000c]/.test(t) && this.open == this.nodes.length - 1) {
        let r = n.content[n.content.length - 1], s = e.previousSibling;
        (!r || s && s.nodeName == "BR" || r.isText && /[ \t\r\n\u000c]$/.test(r.text)) && (t = t.slice(1));
      }
      t && this.insertNode(this.parser.schema.text(t)), this.findInText(e);
    } else
      this.findInside(e);
  }
  addElement(e, t) {
    let n = e.nodeName.toLowerCase(), r;
    xt.hasOwnProperty(n) && this.parser.normalizeLists && tn(e);
    let s = this.options.ruleFromNode && this.options.ruleFromNode(e) || (r = this.parser.matchTag(e, this, t));
    if (s ? s.ignore : en.hasOwnProperty(n))
      this.findInside(e), this.ignoreFallback(e);
    else if (!s || s.skip || s.closeParent) {
      s && s.closeParent ? this.open = Math.max(0, this.open - 1) : s && s.skip.nodeType && (e = s.skip);
      let o, l = this.top, a = this.needsBlock;
      if (St.hasOwnProperty(n))
        o = !0, l.type || (this.needsBlock = !0);
      else if (!e.firstChild) {
        this.leafFallback(e);
        return;
      }
      this.addAll(e), o && this.sync(l), this.needsBlock = a;
    } else
      this.addElementByRule(e, s, s.consuming === !1 ? r : void 0);
  }
  leafFallback(e) {
    e.nodeName == "BR" && this.top.type && this.top.type.inlineContent && this.addTextNode(e.ownerDocument.createTextNode(`
`));
  }
  ignoreFallback(e) {
    e.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent) && this.findPlace(this.parser.schema.text("-"));
  }
  readStyles(e) {
    let t = O.none;
    e:
      for (let n = 0; n < e.length; n += 2)
        for (let r = void 0; ; ) {
          let s = this.parser.matchStyle(e[n], e[n + 1], this, r);
          if (!s)
            continue e;
          if (s.ignore)
            return null;
          if (t = this.parser.schema.marks[s.mark].create(s.attrs).addToSet(t), s.consuming === !1)
            r = s;
          else
            break;
        }
    return t;
  }
  addElementByRule(e, t, n) {
    let r, s, o;
    t.node ? (s = this.parser.schema.nodes[t.node], s.isLeaf ? this.insertNode(s.create(t.attrs)) || this.leafFallback(e) : r = this.enter(s, t.attrs || null, t.preserveWhitespace)) : (o = this.parser.schema.marks[t.mark].create(t.attrs), this.addPendingMark(o));
    let l = this.top;
    if (s && s.isLeaf)
      this.findInside(e);
    else if (n)
      this.addElement(e, n);
    else if (t.getContent)
      this.findInside(e), t.getContent(e, this.parser.schema).forEach((a) => this.insertNode(a));
    else {
      let a = e;
      typeof t.contentElement == "string" ? a = e.querySelector(t.contentElement) : typeof t.contentElement == "function" ? a = t.contentElement(e) : t.contentElement && (a = t.contentElement), this.findAround(e, a, !0), this.addAll(a);
    }
    r && this.sync(l) && this.open--, o && this.removePendingMark(o, l);
  }
  addAll(e, t, n) {
    let r = t || 0;
    for (let s = t ? e.childNodes[t] : e.firstChild, o = n == null ? null : e.childNodes[n]; s != o; s = s.nextSibling, ++r)
      this.findAtPoint(e, r), this.addDOM(s);
    this.findAtPoint(e, r);
  }
  findPlace(e) {
    let t, n;
    for (let r = this.open; r >= 0; r--) {
      let s = this.nodes[r], o = s.findWrapping(e);
      if (o && (!t || t.length > o.length) && (t = o, n = s, !o.length) || s.solid)
        break;
    }
    if (!t)
      return !1;
    this.sync(n);
    for (let r = 0; r < t.length; r++)
      this.enterInner(t[r], null, !1);
    return !0;
  }
  insertNode(e) {
    if (e.isInline && this.needsBlock && !this.top.type) {
      let t = this.textblockFromContext();
      t && this.enterInner(t);
    }
    if (this.findPlace(e)) {
      this.closeExtra();
      let t = this.top;
      t.applyPending(e.type), t.match && (t.match = t.match.matchType(e.type));
      let n = t.activeMarks;
      for (let r = 0; r < e.marks.length; r++)
        (!t.type || t.type.allowsMarkType(e.marks[r].type)) && (n = e.marks[r].addToSet(n));
      return t.content.push(e.mark(n)), !0;
    }
    return !1;
  }
  enter(e, t, n) {
    let r = this.findPlace(e.create(t));
    return r && this.enterInner(e, t, !0, n), r;
  }
  enterInner(e, t = null, n = !1, r) {
    this.closeExtra();
    let s = this.top;
    s.applyPending(e), s.match = s.match && s.match.matchType(e);
    let o = Ue(e, r, s.options);
    s.options & Y && s.content.length == 0 && (o |= Y), this.nodes.push(new fe(e, t, s.activeMarks, s.pendingMarks, n, null, o)), this.open++;
  }
  closeExtra(e = !1) {
    let t = this.nodes.length - 1;
    if (t > this.open) {
      for (; t > this.open; t--)
        this.nodes[t - 1].content.push(this.nodes[t].finish(e));
      this.nodes.length = this.open + 1;
    }
  }
  finish() {
    return this.open = 0, this.closeExtra(this.isOpen), this.nodes[0].finish(this.isOpen || this.options.topOpen);
  }
  sync(e) {
    for (let t = this.open; t >= 0; t--)
      if (this.nodes[t] == e)
        return this.open = t, !0;
    return !1;
  }
  get currentPos() {
    this.closeExtra();
    let e = 0;
    for (let t = this.open; t >= 0; t--) {
      let n = this.nodes[t].content;
      for (let r = n.length - 1; r >= 0; r--)
        e += n[r].nodeSize;
      t && e++;
    }
    return e;
  }
  findAtPoint(e, t) {
    if (this.find)
      for (let n = 0; n < this.find.length; n++)
        this.find[n].node == e && this.find[n].offset == t && (this.find[n].pos = this.currentPos);
  }
  findInside(e) {
    if (this.find)
      for (let t = 0; t < this.find.length; t++)
        this.find[t].pos == null && e.nodeType == 1 && e.contains(this.find[t].node) && (this.find[t].pos = this.currentPos);
  }
  findAround(e, t, n) {
    if (e != t && this.find)
      for (let r = 0; r < this.find.length; r++)
        this.find[r].pos == null && e.nodeType == 1 && e.contains(this.find[r].node) && t.compareDocumentPosition(this.find[r].node) & (n ? 2 : 4) && (this.find[r].pos = this.currentPos);
  }
  findInText(e) {
    if (this.find)
      for (let t = 0; t < this.find.length; t++)
        this.find[t].node == e && (this.find[t].pos = this.currentPos - (e.nodeValue.length - this.find[t].offset));
  }
  matchesContext(e) {
    if (e.indexOf("|") > -1)
      return e.split(/\s*\|\s*/).some(this.matchesContext, this);
    let t = e.split("/"), n = this.options.context, r = !this.isOpen && (!n || n.parent.type == this.nodes[0].type), s = -(n ? n.depth + 1 : 0) + (r ? 0 : 1), o = (l, a) => {
      for (; l >= 0; l--) {
        let c = t[l];
        if (c == "") {
          if (l == t.length - 1 || l == 0)
            continue;
          for (; a >= s; a--)
            if (o(l - 1, a))
              return !0;
          return !1;
        } else {
          let f = a > 0 || a == 0 && r ? this.nodes[a].type : n && a >= s ? n.node(a - s).type : null;
          if (!f || f.name != c && f.groups.indexOf(c) == -1)
            return !1;
          a--;
        }
      }
      return !0;
    };
    return o(t.length - 1, this.open);
  }
  textblockFromContext() {
    let e = this.options.context;
    if (e)
      for (let t = e.depth; t >= 0; t--) {
        let n = e.node(t).contentMatchAt(e.indexAfter(t)).defaultType;
        if (n && n.isTextblock && n.defaultAttrs)
          return n;
      }
    for (let t in this.parser.schema.nodes) {
      let n = this.parser.schema.nodes[t];
      if (n.isTextblock && n.defaultAttrs)
        return n;
    }
  }
  addPendingMark(e) {
    let t = on(e, this.top.pendingMarks);
    t && this.top.stashMarks.push(t), this.top.pendingMarks = e.addToSet(this.top.pendingMarks);
  }
  removePendingMark(e, t) {
    for (let n = this.open; n >= 0; n--) {
      let r = this.nodes[n];
      if (r.pendingMarks.lastIndexOf(e) > -1)
        r.pendingMarks = e.removeFromSet(r.pendingMarks);
      else {
        r.activeMarks = e.removeFromSet(r.activeMarks);
        let o = r.popFromStashMark(e);
        o && r.type && r.type.allowsMarkType(o.type) && (r.activeMarks = o.addToSet(r.activeMarks));
      }
      if (r == t)
        break;
    }
  }
}
function tn(i) {
  for (let e = i.firstChild, t = null; e; e = e.nextSibling) {
    let n = e.nodeType == 1 ? e.nodeName.toLowerCase() : null;
    n && xt.hasOwnProperty(n) && t ? (t.appendChild(e), e = t) : n == "li" ? t = e : n && (t = null);
  }
}
function nn(i, e) {
  return (i.matches || i.msMatchesSelector || i.webkitMatchesSelector || i.mozMatchesSelector).call(i, e);
}
function rn(i) {
  let e = /\s*([\w-]+)\s*:\s*([^;]+)/g, t, n = [];
  for (; t = e.exec(i); )
    n.push(t[1], t[2].trim());
  return n;
}
function Xe(i) {
  let e = {};
  for (let t in i)
    e[t] = i[t];
  return e;
}
function sn(i, e) {
  let t = e.schema.nodes;
  for (let n in t) {
    let r = t[n];
    if (!r.allowsMarkType(i))
      continue;
    let s = [], o = (l) => {
      s.push(l);
      for (let a = 0; a < l.edgeCount; a++) {
        let { type: c, next: f } = l.edge(a);
        if (c == e || s.indexOf(f) < 0 && o(f))
          return !0;
      }
    };
    if (o(r.contentMatch))
      return !0;
  }
}
function on(i, e) {
  for (let t = 0; t < e.length; t++)
    if (i.eq(e[t]))
      return e[t];
}
const vt = 65535, bt = Math.pow(2, 16);
function ln(i, e) {
  return i + e * bt;
}
function Ye(i) {
  return i & vt;
}
function an(i) {
  return (i - (i & vt)) / bt;
}
const Mt = 1, Ct = 2, he = 4, It = 8;
class Ze {
  constructor(e, t, n) {
    this.pos = e, this.delInfo = t, this.recover = n;
  }
  get deleted() {
    return (this.delInfo & It) > 0;
  }
  get deletedBefore() {
    return (this.delInfo & (Mt | he)) > 0;
  }
  get deletedAfter() {
    return (this.delInfo & (Ct | he)) > 0;
  }
  get deletedAcross() {
    return (this.delInfo & he) > 0;
  }
}
class N {
  constructor(e, t = !1) {
    if (this.ranges = e, this.inverted = t, !e.length && N.empty)
      return N.empty;
  }
  recover(e) {
    let t = 0, n = Ye(e);
    if (!this.inverted)
      for (let r = 0; r < n; r++)
        t += this.ranges[r * 3 + 2] - this.ranges[r * 3 + 1];
    return this.ranges[n * 3] + t + an(e);
  }
  mapResult(e, t = 1) {
    return this._map(e, t, !1);
  }
  map(e, t = 1) {
    return this._map(e, t, !0);
  }
  _map(e, t, n) {
    let r = 0, s = this.inverted ? 2 : 1, o = this.inverted ? 1 : 2;
    for (let l = 0; l < this.ranges.length; l += 3) {
      let a = this.ranges[l] - (this.inverted ? r : 0);
      if (a > e)
        break;
      let c = this.ranges[l + s], f = this.ranges[l + o], u = a + c;
      if (e <= u) {
        let h = c ? e == a ? -1 : e == u ? 1 : t : t, d = a + r + (h < 0 ? 0 : f);
        if (n)
          return d;
        let m = e == (t < 0 ? a : u) ? null : ln(l / 3, e - a), p = e == a ? Ct : e == u ? Mt : he;
        return (t < 0 ? e != a : e != u) && (p |= It), new Ze(d, p, m);
      }
      r += f - c;
    }
    return n ? e + r : new Ze(e + r, 0, null);
  }
  touches(e, t) {
    let n = 0, r = Ye(t), s = this.inverted ? 2 : 1, o = this.inverted ? 1 : 2;
    for (let l = 0; l < this.ranges.length; l += 3) {
      let a = this.ranges[l] - (this.inverted ? n : 0);
      if (a > e)
        break;
      let c = this.ranges[l + s], f = a + c;
      if (e <= f && l == r * 3)
        return !0;
      n += this.ranges[l + o] - c;
    }
    return !1;
  }
  forEach(e) {
    let t = this.inverted ? 2 : 1, n = this.inverted ? 1 : 2;
    for (let r = 0, s = 0; r < this.ranges.length; r += 3) {
      let o = this.ranges[r], l = o - (this.inverted ? s : 0), a = o + (this.inverted ? 0 : s), c = this.ranges[r + t], f = this.ranges[r + n];
      e(l, l + c, a, a + f), s += f - c;
    }
  }
  invert() {
    return new N(this.ranges, !this.inverted);
  }
  toString() {
    return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
  }
  static offset(e) {
    return e == 0 ? N.empty : new N(e < 0 ? [0, -e, 0] : [0, 0, e]);
  }
}
N.empty = new N([]);
const Ce = /* @__PURE__ */ Object.create(null);
class C {
  getMap() {
    return N.empty;
  }
  merge(e) {
    return null;
  }
  static fromJSON(e, t) {
    if (!t || !t.stepType)
      throw new RangeError("Invalid input for Step.fromJSON");
    let n = Ce[t.stepType];
    if (!n)
      throw new RangeError(`No step type ${t.stepType} defined`);
    return n.fromJSON(e, t);
  }
  static jsonID(e, t) {
    if (e in Ce)
      throw new RangeError("Duplicate use of step JSON ID " + e);
    return Ce[e] = t, t.prototype.jsonID = e, t;
  }
}
class b {
  constructor(e, t) {
    this.doc = e, this.failed = t;
  }
  static ok(e) {
    return new b(e, null);
  }
  static fail(e) {
    return new b(null, e);
  }
  static fromReplace(e, t, n, r) {
    try {
      return b.ok(e.replace(t, n, r));
    } catch (s) {
      if (s instanceof yt)
        return b.fail(s.message);
      throw s;
    }
  }
}
function Je(i, e, t) {
  let n = [];
  for (let r = 0; r < i.childCount; r++) {
    let s = i.child(r);
    s.content.size && (s = s.copy(Je(s.content, e, s))), s.isInline && (s = e(s, t, r)), n.push(s);
  }
  return g.fromArray(n);
}
class D extends C {
  constructor(e, t, n) {
    super(), this.from = e, this.to = t, this.mark = n;
  }
  apply(e) {
    let t = e.slice(this.from, this.to), n = e.resolve(this.from), r = n.node(n.sharedDepth(this.to)), s = new y(Je(t.content, (o, l) => !o.isAtom || !l.type.allowsMarkType(this.mark.type) ? o : o.mark(this.mark.addToSet(o.marks)), r), t.openStart, t.openEnd);
    return b.fromReplace(e, this.from, this.to, s);
  }
  invert() {
    return new L(this.from, this.to, this.mark);
  }
  map(e) {
    let t = e.mapResult(this.from, 1), n = e.mapResult(this.to, -1);
    return t.deleted && n.deleted || t.pos >= n.pos ? null : new D(t.pos, n.pos, this.mark);
  }
  merge(e) {
    return e instanceof D && e.mark.eq(this.mark) && this.from <= e.to && this.to >= e.from ? new D(Math.min(this.from, e.from), Math.max(this.to, e.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "addMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  static fromJSON(e, t) {
    if (typeof t.from != "number" || typeof t.to != "number")
      throw new RangeError("Invalid input for AddMarkStep.fromJSON");
    return new D(t.from, t.to, e.markFromJSON(t.mark));
  }
}
C.jsonID("addMark", D);
class L extends C {
  constructor(e, t, n) {
    super(), this.from = e, this.to = t, this.mark = n;
  }
  apply(e) {
    let t = e.slice(this.from, this.to), n = new y(Je(t.content, (r) => r.mark(this.mark.removeFromSet(r.marks)), e), t.openStart, t.openEnd);
    return b.fromReplace(e, this.from, this.to, n);
  }
  invert() {
    return new D(this.from, this.to, this.mark);
  }
  map(e) {
    let t = e.mapResult(this.from, 1), n = e.mapResult(this.to, -1);
    return t.deleted && n.deleted || t.pos >= n.pos ? null : new L(t.pos, n.pos, this.mark);
  }
  merge(e) {
    return e instanceof L && e.mark.eq(this.mark) && this.from <= e.to && this.to >= e.from ? new L(Math.min(this.from, e.from), Math.max(this.to, e.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "removeMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  static fromJSON(e, t) {
    if (typeof t.from != "number" || typeof t.to != "number")
      throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
    return new L(t.from, t.to, e.markFromJSON(t.mark));
  }
}
C.jsonID("removeMark", L);
class W extends C {
  constructor(e, t) {
    super(), this.pos = e, this.mark = t;
  }
  apply(e) {
    let t = e.nodeAt(this.pos);
    if (!t)
      return b.fail("No node at mark step's position");
    let n = t.type.create(t.attrs, null, this.mark.addToSet(t.marks));
    return b.fromReplace(e, this.pos, this.pos + 1, new y(g.from(n), 0, t.isLeaf ? 0 : 1));
  }
  invert(e) {
    let t = e.nodeAt(this.pos);
    if (t) {
      let n = this.mark.addToSet(t.marks);
      if (n.length == t.marks.length) {
        for (let r = 0; r < t.marks.length; r++)
          if (!t.marks[r].isInSet(n))
            return new W(this.pos, t.marks[r]);
        return new W(this.pos, this.mark);
      }
    }
    return new ee(this.pos, this.mark);
  }
  map(e) {
    let t = e.mapResult(this.pos, 1);
    return t.deletedAfter ? null : new W(t.pos, this.mark);
  }
  toJSON() {
    return { stepType: "addNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  static fromJSON(e, t) {
    if (typeof t.pos != "number")
      throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
    return new W(t.pos, e.markFromJSON(t.mark));
  }
}
C.jsonID("addNodeMark", W);
class ee extends C {
  constructor(e, t) {
    super(), this.pos = e, this.mark = t;
  }
  apply(e) {
    let t = e.nodeAt(this.pos);
    if (!t)
      return b.fail("No node at mark step's position");
    let n = t.type.create(t.attrs, null, this.mark.removeFromSet(t.marks));
    return b.fromReplace(e, this.pos, this.pos + 1, new y(g.from(n), 0, t.isLeaf ? 0 : 1));
  }
  invert(e) {
    let t = e.nodeAt(this.pos);
    return !t || !this.mark.isInSet(t.marks) ? this : new W(this.pos, this.mark);
  }
  map(e) {
    let t = e.mapResult(this.pos, 1);
    return t.deletedAfter ? null : new ee(t.pos, this.mark);
  }
  toJSON() {
    return { stepType: "removeNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  static fromJSON(e, t) {
    if (typeof t.pos != "number")
      throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
    return new ee(t.pos, e.markFromJSON(t.mark));
  }
}
C.jsonID("removeNodeMark", ee);
class A extends C {
  constructor(e, t, n, r = !1) {
    super(), this.from = e, this.to = t, this.slice = n, this.structure = r;
  }
  apply(e) {
    return this.structure && Fe(e, this.from, this.to) ? b.fail("Structure replace would overwrite content") : b.fromReplace(e, this.from, this.to, this.slice);
  }
  getMap() {
    return new N([this.from, this.to - this.from, this.slice.size]);
  }
  invert(e) {
    return new A(this.from, this.from + this.slice.size, e.slice(this.from, this.to));
  }
  map(e) {
    let t = e.mapResult(this.from, 1), n = e.mapResult(this.to, -1);
    return t.deletedAcross && n.deletedAcross ? null : new A(t.pos, Math.max(t.pos, n.pos), this.slice);
  }
  merge(e) {
    if (!(e instanceof A) || e.structure || this.structure)
      return null;
    if (this.from + this.slice.size == e.from && !this.slice.openEnd && !e.slice.openStart) {
      let t = this.slice.size + e.slice.size == 0 ? y.empty : new y(this.slice.content.append(e.slice.content), this.slice.openStart, e.slice.openEnd);
      return new A(this.from, this.to + (e.to - e.from), t, this.structure);
    } else if (e.to == this.from && !this.slice.openStart && !e.slice.openEnd) {
      let t = this.slice.size + e.slice.size == 0 ? y.empty : new y(e.slice.content.append(this.slice.content), e.slice.openStart, this.slice.openEnd);
      return new A(e.from, this.to, t, this.structure);
    } else
      return null;
  }
  toJSON() {
    let e = { stepType: "replace", from: this.from, to: this.to };
    return this.slice.size && (e.slice = this.slice.toJSON()), this.structure && (e.structure = !0), e;
  }
  static fromJSON(e, t) {
    if (typeof t.from != "number" || typeof t.to != "number")
      throw new RangeError("Invalid input for ReplaceStep.fromJSON");
    return new A(t.from, t.to, y.fromJSON(e, t.slice), !!t.structure);
  }
}
C.jsonID("replace", A);
class T extends C {
  constructor(e, t, n, r, s, o, l = !1) {
    super(), this.from = e, this.to = t, this.gapFrom = n, this.gapTo = r, this.slice = s, this.insert = o, this.structure = l;
  }
  apply(e) {
    if (this.structure && (Fe(e, this.from, this.gapFrom) || Fe(e, this.gapTo, this.to)))
      return b.fail("Structure gap-replace would overwrite content");
    let t = e.slice(this.gapFrom, this.gapTo);
    if (t.openStart || t.openEnd)
      return b.fail("Gap is not a flat range");
    let n = this.slice.insertAt(this.insert, t.content);
    return n ? b.fromReplace(e, this.from, this.to, n) : b.fail("Content does not fit in gap");
  }
  getMap() {
    return new N([
      this.from,
      this.gapFrom - this.from,
      this.insert,
      this.gapTo,
      this.to - this.gapTo,
      this.slice.size - this.insert
    ]);
  }
  invert(e) {
    let t = this.gapTo - this.gapFrom;
    return new T(this.from, this.from + this.slice.size + t, this.from + this.insert, this.from + this.insert + t, e.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
  }
  map(e) {
    let t = e.mapResult(this.from, 1), n = e.mapResult(this.to, -1), r = e.map(this.gapFrom, -1), s = e.map(this.gapTo, 1);
    return t.deletedAcross && n.deletedAcross || r < t.pos || s > n.pos ? null : new T(t.pos, n.pos, r, s, this.slice, this.insert, this.structure);
  }
  toJSON() {
    let e = {
      stepType: "replaceAround",
      from: this.from,
      to: this.to,
      gapFrom: this.gapFrom,
      gapTo: this.gapTo,
      insert: this.insert
    };
    return this.slice.size && (e.slice = this.slice.toJSON()), this.structure && (e.structure = !0), e;
  }
  static fromJSON(e, t) {
    if (typeof t.from != "number" || typeof t.to != "number" || typeof t.gapFrom != "number" || typeof t.gapTo != "number" || typeof t.insert != "number")
      throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
    return new T(t.from, t.to, t.gapFrom, t.gapTo, y.fromJSON(e, t.slice), t.insert, !!t.structure);
  }
}
C.jsonID("replaceAround", T);
function Fe(i, e, t) {
  let n = i.resolve(e), r = t - e, s = n.depth;
  for (; r > 0 && s > 0 && n.indexAfter(s) == n.node(s).childCount; )
    s--, r--;
  if (r > 0) {
    let o = n.node(s).maybeChild(n.indexAfter(s));
    for (; r > 0; ) {
      if (!o || o.isLeaf)
        return !0;
      o = o.firstChild, r--;
    }
  }
  return !1;
}
function cn(i, e, t) {
  return (e == 0 || i.canReplace(e, i.childCount)) && (t == i.childCount || i.canReplace(0, t));
}
function ie(i) {
  let t = i.parent.content.cutByIndex(i.startIndex, i.endIndex);
  for (let n = i.depth; ; --n) {
    let r = i.$from.node(n), s = i.$from.index(n), o = i.$to.indexAfter(n);
    if (n < i.depth && r.canReplace(s, o, t))
      return n;
    if (n == 0 || r.type.spec.isolating || !cn(r, s, o))
      break;
  }
  return null;
}
function Et(i, e, t = null, n = i) {
  let r = fn(i, e), s = r && un(n, e);
  return s ? r.map(_e).concat({ type: e, attrs: t }).concat(s.map(_e)) : null;
}
function _e(i) {
  return { type: i, attrs: null };
}
function fn(i, e) {
  let { parent: t, startIndex: n, endIndex: r } = i, s = t.contentMatchAt(n).findWrapping(e);
  if (!s)
    return null;
  let o = s.length ? s[0] : e;
  return t.canReplaceWith(n, r, o) ? s : null;
}
function un(i, e) {
  let { parent: t, startIndex: n, endIndex: r } = i, s = t.child(n), o = e.contentMatch.findWrapping(s.type);
  if (!o)
    return null;
  let a = (o.length ? o[o.length - 1] : e).contentMatch;
  for (let c = n; a && c < r; c++)
    a = a.matchType(t.child(c).type);
  return !a || !a.validEnd ? null : o;
}
function Tt(i, e, t = 1, n) {
  let r = i.resolve(e), s = r.depth - t, o = n && n[n.length - 1] || r.parent;
  if (s < 0 || r.parent.type.spec.isolating || !r.parent.canReplace(r.index(), r.parent.childCount) || !o.type.validContent(r.parent.content.cutByIndex(r.index(), r.parent.childCount)))
    return !1;
  for (let c = r.depth - 1, f = t - 2; c > s; c--, f--) {
    let u = r.node(c), h = r.index(c);
    if (u.type.spec.isolating)
      return !1;
    let d = u.content.cutByIndex(h, u.childCount), m = n && n[f] || u;
    if (m != u && (d = d.replaceChild(0, m.type.create(m.attrs))), !u.canReplace(h + 1, u.childCount) || !m.type.validContent(d))
      return !1;
  }
  let l = r.indexAfter(s), a = n && n[0];
  return r.node(s).canReplaceWith(l, l, a ? a.type : r.node(s + 1).type);
}
function Ot(i, e) {
  let t = i.resolve(e), n = t.index();
  return hn(t.nodeBefore, t.nodeAfter) && t.parent.canReplace(n, n + 1);
}
function hn(i, e) {
  return !!(i && e && !i.isLeaf && i.canAppend(e));
}
function Nt(i, e, t = e, n = y.empty) {
  if (e == t && !n.size)
    return null;
  let r = i.resolve(e), s = i.resolve(t);
  return dn(r, s, n) ? new A(e, t, n) : new pn(r, s, n).fit();
}
function dn(i, e, t) {
  return !t.openStart && !t.openEnd && i.start() == e.start() && i.parent.canReplace(i.index(), e.index(), t.content);
}
class pn {
  constructor(e, t, n) {
    this.$from = e, this.$to = t, this.unplaced = n, this.frontier = [], this.placed = g.empty;
    for (let r = 0; r <= e.depth; r++) {
      let s = e.node(r);
      this.frontier.push({
        type: s.type,
        match: s.contentMatchAt(e.indexAfter(r))
      });
    }
    for (let r = e.depth; r > 0; r--)
      this.placed = g.from(e.node(r).copy(this.placed));
  }
  get depth() {
    return this.frontier.length - 1;
  }
  fit() {
    for (; this.unplaced.size; ) {
      let c = this.findFittable();
      c ? this.placeNodes(c) : this.openMore() || this.dropNode();
    }
    let e = this.mustMoveInline(), t = this.placed.size - this.depth - this.$from.depth, n = this.$from, r = this.close(e < 0 ? this.$to : n.doc.resolve(e));
    if (!r)
      return null;
    let s = this.placed, o = n.depth, l = r.depth;
    for (; o && l && s.childCount == 1; )
      s = s.firstChild.content, o--, l--;
    let a = new y(s, o, l);
    return e > -1 ? new T(n.pos, e, this.$to.pos, this.$to.end(), a, t) : a.size || n.pos != this.$to.pos ? new A(n.pos, r.pos, a) : null;
  }
  findFittable() {
    for (let e = 1; e <= 2; e++)
      for (let t = this.unplaced.openStart; t >= 0; t--) {
        let n, r = null;
        t ? (r = Ie(this.unplaced.content, t - 1).firstChild, n = r.content) : n = this.unplaced.content;
        let s = n.firstChild;
        for (let o = this.depth; o >= 0; o--) {
          let { type: l, match: a } = this.frontier[o], c, f = null;
          if (e == 1 && (s ? a.matchType(s.type) || (f = a.fillBefore(g.from(s), !1)) : r && l.compatibleContent(r.type)))
            return { sliceDepth: t, frontierDepth: o, parent: r, inject: f };
          if (e == 2 && s && (c = a.findWrapping(s.type)))
            return { sliceDepth: t, frontierDepth: o, parent: r, wrap: c };
          if (r && a.matchType(r.type))
            break;
        }
      }
  }
  openMore() {
    let { content: e, openStart: t, openEnd: n } = this.unplaced, r = Ie(e, t);
    return !r.childCount || r.firstChild.isLeaf ? !1 : (this.unplaced = new y(e, t + 1, Math.max(n, r.size + t >= e.size - n ? t + 1 : 0)), !0);
  }
  dropNode() {
    let { content: e, openStart: t, openEnd: n } = this.unplaced, r = Ie(e, t);
    if (r.childCount <= 1 && t > 0) {
      let s = e.size - t <= t + r.size;
      this.unplaced = new y(Q(e, t - 1, 1), t - 1, s ? t - 1 : n);
    } else
      this.unplaced = new y(Q(e, t, 1), t, n);
  }
  placeNodes({ sliceDepth: e, frontierDepth: t, parent: n, inject: r, wrap: s }) {
    for (; this.depth > t; )
      this.closeFrontierNode();
    if (s)
      for (let p = 0; p < s.length; p++)
        this.openFrontierNode(s[p]);
    let o = this.unplaced, l = n ? n.content : o.content, a = o.openStart - e, c = 0, f = [], { match: u, type: h } = this.frontier[t];
    if (r) {
      for (let p = 0; p < r.childCount; p++)
        f.push(r.child(p));
      u = u.matchFragment(r);
    }
    let d = l.size + e - (o.content.size - o.openEnd);
    for (; c < l.childCount; ) {
      let p = l.child(c), w = u.matchType(p.type);
      if (!w)
        break;
      c++, (c > 1 || a == 0 || p.content.size) && (u = w, f.push(At(p.mark(h.allowedMarks(p.marks)), c == 1 ? a : 0, c == l.childCount ? d : -1)));
    }
    let m = c == l.childCount;
    m || (d = -1), this.placed = X(this.placed, t, g.from(f)), this.frontier[t].match = u, m && d < 0 && n && n.type == this.frontier[this.depth].type && this.frontier.length > 1 && this.closeFrontierNode();
    for (let p = 0, w = l; p < d; p++) {
      let S = w.lastChild;
      this.frontier.push({ type: S.type, match: S.contentMatchAt(S.childCount) }), w = S.content;
    }
    this.unplaced = m ? e == 0 ? y.empty : new y(Q(o.content, e - 1, 1), e - 1, d < 0 ? o.openEnd : e - 1) : new y(Q(o.content, e, c), o.openStart, o.openEnd);
  }
  mustMoveInline() {
    if (!this.$to.parent.isTextblock)
      return -1;
    let e = this.frontier[this.depth], t;
    if (!e.type.isTextblock || !Ee(this.$to, this.$to.depth, e.type, e.match, !1) || this.$to.depth == this.depth && (t = this.findCloseLevel(this.$to)) && t.depth == this.depth)
      return -1;
    let { depth: n } = this.$to, r = this.$to.after(n);
    for (; n > 1 && r == this.$to.end(--n); )
      ++r;
    return r;
  }
  findCloseLevel(e) {
    e:
      for (let t = Math.min(this.depth, e.depth); t >= 0; t--) {
        let { match: n, type: r } = this.frontier[t], s = t < e.depth && e.end(t + 1) == e.pos + (e.depth - (t + 1)), o = Ee(e, t, r, n, s);
        if (!!o) {
          for (let l = t - 1; l >= 0; l--) {
            let { match: a, type: c } = this.frontier[l], f = Ee(e, l, c, a, !0);
            if (!f || f.childCount)
              continue e;
          }
          return { depth: t, fit: o, move: s ? e.doc.resolve(e.after(t + 1)) : e };
        }
      }
  }
  close(e) {
    let t = this.findCloseLevel(e);
    if (!t)
      return null;
    for (; this.depth > t.depth; )
      this.closeFrontierNode();
    t.fit.childCount && (this.placed = X(this.placed, t.depth, t.fit)), e = t.move;
    for (let n = t.depth + 1; n <= e.depth; n++) {
      let r = e.node(n), s = r.type.contentMatch.fillBefore(r.content, !0, e.index(n));
      this.openFrontierNode(r.type, r.attrs, s);
    }
    return e;
  }
  openFrontierNode(e, t = null, n) {
    let r = this.frontier[this.depth];
    r.match = r.match.matchType(e), this.placed = X(this.placed, this.depth, g.from(e.create(t, n))), this.frontier.push({ type: e, match: e.contentMatch });
  }
  closeFrontierNode() {
    let t = this.frontier.pop().match.fillBefore(g.empty, !0);
    t.childCount && (this.placed = X(this.placed, this.frontier.length, t));
  }
}
function Q(i, e, t) {
  return e == 0 ? i.cutByIndex(t, i.childCount) : i.replaceChild(0, i.firstChild.copy(Q(i.firstChild.content, e - 1, t)));
}
function X(i, e, t) {
  return e == 0 ? i.append(t) : i.replaceChild(i.childCount - 1, i.lastChild.copy(X(i.lastChild.content, e - 1, t)));
}
function Ie(i, e) {
  for (let t = 0; t < e; t++)
    i = i.firstChild.content;
  return i;
}
function At(i, e, t) {
  if (e <= 0)
    return i;
  let n = i.content;
  return e > 1 && (n = n.replaceChild(0, At(n.firstChild, e - 1, n.childCount == 1 ? t - 1 : 0))), e > 0 && (n = i.type.contentMatch.fillBefore(n).append(n), t <= 0 && (n = n.append(i.type.contentMatch.matchFragment(n).fillBefore(g.empty, !0)))), i.copy(n);
}
function Ee(i, e, t, n, r) {
  let s = i.node(e), o = r ? i.indexAfter(e) : i.index(e);
  if (o == s.childCount && !t.compatibleContent(s.type))
    return null;
  let l = n.fillBefore(s.content, !0, o);
  return l && !mn(t, s.content, o) ? l : null;
}
function mn(i, e, t) {
  for (let n = t; n < e.childCount; n++)
    if (!i.allowsMarks(e.child(n).marks))
      return !0;
  return !1;
}
class Z extends C {
  constructor(e, t, n) {
    super(), this.pos = e, this.attr = t, this.value = n;
  }
  apply(e) {
    let t = e.nodeAt(this.pos);
    if (!t)
      return b.fail("No node at attribute step's position");
    let n = /* @__PURE__ */ Object.create(null);
    for (let s in t.attrs)
      n[s] = t.attrs[s];
    n[this.attr] = this.value;
    let r = t.type.create(n, null, t.marks);
    return b.fromReplace(e, this.pos, this.pos + 1, new y(g.from(r), 0, t.isLeaf ? 0 : 1));
  }
  getMap() {
    return N.empty;
  }
  invert(e) {
    return new Z(this.pos, this.attr, e.nodeAt(this.pos).attrs[this.attr]);
  }
  map(e) {
    let t = e.mapResult(this.pos, 1);
    return t.deletedAfter ? null : new Z(t.pos, this.attr, this.value);
  }
  toJSON() {
    return { stepType: "attr", pos: this.pos, attr: this.attr, value: this.value };
  }
  static fromJSON(e, t) {
    if (typeof t.pos != "number" || typeof t.attr != "string")
      throw new RangeError("Invalid input for AttrStep.fromJSON");
    return new Z(t.pos, t.attr, t.value);
  }
}
C.jsonID("attr", Z);
let te = class extends Error {
};
te = function i(e) {
  let t = Error.call(this, e);
  return t.__proto__ = i.prototype, t;
};
te.prototype = Object.create(Error.prototype);
te.prototype.constructor = te;
te.prototype.name = "TransformError";
const Te = /* @__PURE__ */ Object.create(null);
class k {
  constructor(e, t, n) {
    this.$anchor = e, this.$head = t, this.ranges = n || [new Rt(e.min(t), e.max(t))];
  }
  get anchor() {
    return this.$anchor.pos;
  }
  get head() {
    return this.$head.pos;
  }
  get from() {
    return this.$from.pos;
  }
  get to() {
    return this.$to.pos;
  }
  get $from() {
    return this.ranges[0].$from;
  }
  get $to() {
    return this.ranges[0].$to;
  }
  get empty() {
    let e = this.ranges;
    for (let t = 0; t < e.length; t++)
      if (e[t].$from.pos != e[t].$to.pos)
        return !1;
    return !0;
  }
  content() {
    return this.$from.doc.slice(this.from, this.to, !0);
  }
  replace(e, t = y.empty) {
    let n = t.content.lastChild, r = null;
    for (let l = 0; l < t.openEnd; l++)
      r = n, n = n.lastChild;
    let s = e.steps.length, o = this.ranges;
    for (let l = 0; l < o.length; l++) {
      let { $from: a, $to: c } = o[l], f = e.mapping.slice(s);
      e.replaceRange(f.map(a.pos), f.map(c.pos), l ? y.empty : t), l == 0 && nt(e, s, (n ? n.isInline : r && r.isTextblock) ? -1 : 1);
    }
  }
  replaceWith(e, t) {
    let n = e.steps.length, r = this.ranges;
    for (let s = 0; s < r.length; s++) {
      let { $from: o, $to: l } = r[s], a = e.mapping.slice(n), c = a.map(o.pos), f = a.map(l.pos);
      s ? e.deleteRange(c, f) : (e.replaceRangeWith(c, f, t), nt(e, n, t.isInline ? -1 : 1));
    }
  }
  static findFrom(e, t, n = !1) {
    let r = e.parent.inlineContent ? new v(e) : j(e.node(0), e.parent, e.pos, e.index(), t, n);
    if (r)
      return r;
    for (let s = e.depth - 1; s >= 0; s--) {
      let o = t < 0 ? j(e.node(0), e.node(s), e.before(s + 1), e.index(s), t, n) : j(e.node(0), e.node(s), e.after(s + 1), e.index(s) + 1, t, n);
      if (o)
        return o;
    }
    return null;
  }
  static near(e, t = 1) {
    return this.findFrom(e, t) || this.findFrom(e, -t) || new F(e.node(0));
  }
  static atStart(e) {
    return j(e, e, 0, 0, 1) || new F(e);
  }
  static atEnd(e) {
    return j(e, e, e.content.size, e.childCount, -1) || new F(e);
  }
  static fromJSON(e, t) {
    if (!t || !t.type)
      throw new RangeError("Invalid input for Selection.fromJSON");
    let n = Te[t.type];
    if (!n)
      throw new RangeError(`No selection type ${t.type} defined`);
    return n.fromJSON(e, t);
  }
  static jsonID(e, t) {
    if (e in Te)
      throw new RangeError("Duplicate use of selection JSON ID " + e);
    return Te[e] = t, t.prototype.jsonID = e, t;
  }
  getBookmark() {
    return v.between(this.$anchor, this.$head).getBookmark();
  }
}
k.prototype.visible = !0;
class Rt {
  constructor(e, t) {
    this.$from = e, this.$to = t;
  }
}
let et = !1;
function tt(i) {
  !et && !i.parent.inlineContent && (et = !0, console.warn("TextSelection endpoint not pointing into a node with inline content (" + i.parent.type.name + ")"));
}
class v extends k {
  constructor(e, t = e) {
    tt(e), tt(t), super(e, t);
  }
  get $cursor() {
    return this.$anchor.pos == this.$head.pos ? this.$head : null;
  }
  map(e, t) {
    let n = e.resolve(t.map(this.head));
    if (!n.parent.inlineContent)
      return k.near(n);
    let r = e.resolve(t.map(this.anchor));
    return new v(r.parent.inlineContent ? r : n, n);
  }
  replace(e, t = y.empty) {
    if (super.replace(e, t), t == y.empty) {
      let n = this.$from.marksAcross(this.$to);
      n && e.ensureMarks(n);
    }
  }
  eq(e) {
    return e instanceof v && e.anchor == this.anchor && e.head == this.head;
  }
  getBookmark() {
    return new ve(this.anchor, this.head);
  }
  toJSON() {
    return { type: "text", anchor: this.anchor, head: this.head };
  }
  static fromJSON(e, t) {
    if (typeof t.anchor != "number" || typeof t.head != "number")
      throw new RangeError("Invalid input for TextSelection.fromJSON");
    return new v(e.resolve(t.anchor), e.resolve(t.head));
  }
  static create(e, t, n = t) {
    let r = e.resolve(t);
    return new this(r, n == t ? r : e.resolve(n));
  }
  static between(e, t, n) {
    let r = e.pos - t.pos;
    if ((!n || r) && (n = r >= 0 ? 1 : -1), !t.parent.inlineContent) {
      let s = k.findFrom(t, n, !0) || k.findFrom(t, -n, !0);
      if (s)
        t = s.$head;
      else
        return k.near(t, n);
    }
    return e.parent.inlineContent || (r == 0 ? e = t : (e = (k.findFrom(e, -n, !0) || k.findFrom(e, n, !0)).$anchor, e.pos < t.pos != r < 0 && (e = t))), new v(e, t);
  }
}
k.jsonID("text", v);
class ve {
  constructor(e, t) {
    this.anchor = e, this.head = t;
  }
  map(e) {
    return new ve(e.map(this.anchor), e.map(this.head));
  }
  resolve(e) {
    return v.between(e.resolve(this.anchor), e.resolve(this.head));
  }
}
class x extends k {
  constructor(e) {
    let t = e.nodeAfter, n = e.node(0).resolve(e.pos + t.nodeSize);
    super(e, n), this.node = t;
  }
  map(e, t) {
    let { deleted: n, pos: r } = t.mapResult(this.anchor), s = e.resolve(r);
    return n ? k.near(s) : new x(s);
  }
  content() {
    return new y(g.from(this.node), 0, 0);
  }
  eq(e) {
    return e instanceof x && e.anchor == this.anchor;
  }
  toJSON() {
    return { type: "node", anchor: this.anchor };
  }
  getBookmark() {
    return new De(this.anchor);
  }
  static fromJSON(e, t) {
    if (typeof t.anchor != "number")
      throw new RangeError("Invalid input for NodeSelection.fromJSON");
    return new x(e.resolve(t.anchor));
  }
  static create(e, t) {
    return new x(e.resolve(t));
  }
  static isSelectable(e) {
    return !e.isText && e.type.spec.selectable !== !1;
  }
}
x.prototype.visible = !1;
k.jsonID("node", x);
class De {
  constructor(e) {
    this.anchor = e;
  }
  map(e) {
    let { deleted: t, pos: n } = e.mapResult(this.anchor);
    return t ? new ve(n, n) : new De(n);
  }
  resolve(e) {
    let t = e.resolve(this.anchor), n = t.nodeAfter;
    return n && x.isSelectable(n) ? new x(t) : k.near(t);
  }
}
class F extends k {
  constructor(e) {
    super(e.resolve(0), e.resolve(e.content.size));
  }
  replace(e, t = y.empty) {
    if (t == y.empty) {
      e.delete(0, e.doc.content.size);
      let n = k.atStart(e.doc);
      n.eq(e.selection) || e.setSelection(n);
    } else
      super.replace(e, t);
  }
  toJSON() {
    return { type: "all" };
  }
  static fromJSON(e) {
    return new F(e);
  }
  map(e) {
    return new F(e);
  }
  eq(e) {
    return e instanceof F;
  }
  getBookmark() {
    return gn;
  }
}
k.jsonID("all", F);
const gn = {
  map() {
    return this;
  },
  resolve(i) {
    return new F(i);
  }
};
function j(i, e, t, n, r, s = !1) {
  if (e.inlineContent)
    return v.create(i, t);
  for (let o = n - (r > 0 ? 0 : 1); r > 0 ? o < e.childCount : o >= 0; o += r) {
    let l = e.child(o);
    if (l.isAtom) {
      if (!s && x.isSelectable(l))
        return x.create(i, t - (r < 0 ? l.nodeSize : 0));
    } else {
      let a = j(i, l, t + r, r < 0 ? l.childCount : 0, r, s);
      if (a)
        return a;
    }
    t += l.nodeSize * r;
  }
  return null;
}
function nt(i, e, t) {
  let n = i.steps.length - 1;
  if (n < e)
    return;
  let r = i.steps[n];
  if (!(r instanceof A || r instanceof T))
    return;
  let s = i.mapping.maps[n], o;
  s.forEach((l, a, c, f) => {
    o == null && (o = f);
  }), i.setSelection(k.near(i.doc.resolve(o), t));
}
function rt(i, e) {
  return !e || !i ? i : i.bind(e);
}
class ue {
  constructor(e, t, n) {
    this.name = e, this.init = rt(t.init, n), this.apply = rt(t.apply, n);
  }
}
new ue("doc", {
  init(i) {
    return i.doc || i.schema.topNodeType.createAndFill();
  },
  apply(i) {
    return i.doc;
  }
}), new ue("selection", {
  init(i, e) {
    return i.selection || k.atStart(e.doc);
  },
  apply(i) {
    return i.selection;
  }
}), new ue("storedMarks", {
  init(i) {
    return i.storedMarks || null;
  },
  apply(i, e, t, n) {
    return n.selection.$cursor ? i.storedMarks : null;
  }
}), new ue("scrollToSelection", {
  init() {
    return 0;
  },
  apply(i, e) {
    return i.scrolledIntoView ? e + 1 : e;
  }
});
function zt(i, e, t) {
  for (let n in i) {
    let r = i[n];
    r instanceof Function ? r = r.bind(e) : n == "handleDOMEvents" && (r = zt(r, e, {})), t[n] = r;
  }
  return t;
}
class se {
  constructor(e) {
    this.spec = e, this.props = {}, e.props && zt(e.props, this, this.props), this.key = e.key ? e.key.key : Ft("plugin");
  }
  getState(e) {
    return e[this.key];
  }
}
const Oe = /* @__PURE__ */ Object.create(null);
function Ft(i) {
  return i in Oe ? i + "$" + ++Oe[i] : (Oe[i] = 0, i + "$");
}
class oe {
  constructor(e = "key") {
    this.key = Ft(e);
  }
  get(e) {
    return e.config.pluginsByKey[this.key];
  }
  getState(e) {
    return e[this.key];
  }
}
const Bt = 65535, $t = Math.pow(2, 16);
function yn(i, e) {
  return i + e * $t;
}
function it(i) {
  return i & Bt;
}
function wn(i) {
  return (i - (i & Bt)) / $t;
}
const Pt = 1, Jt = 2, de = 4, Dt = 8;
class st {
  constructor(e, t, n) {
    this.pos = e, this.delInfo = t, this.recover = n;
  }
  get deleted() {
    return (this.delInfo & Dt) > 0;
  }
  get deletedBefore() {
    return (this.delInfo & (Pt | de)) > 0;
  }
  get deletedAfter() {
    return (this.delInfo & (Jt | de)) > 0;
  }
  get deletedAcross() {
    return (this.delInfo & de) > 0;
  }
}
class R {
  constructor(e, t = !1) {
    if (this.ranges = e, this.inverted = t, !e.length && R.empty)
      return R.empty;
  }
  recover(e) {
    let t = 0, n = it(e);
    if (!this.inverted)
      for (let r = 0; r < n; r++)
        t += this.ranges[r * 3 + 2] - this.ranges[r * 3 + 1];
    return this.ranges[n * 3] + t + wn(e);
  }
  mapResult(e, t = 1) {
    return this._map(e, t, !1);
  }
  map(e, t = 1) {
    return this._map(e, t, !0);
  }
  _map(e, t, n) {
    let r = 0, s = this.inverted ? 2 : 1, o = this.inverted ? 1 : 2;
    for (let l = 0; l < this.ranges.length; l += 3) {
      let a = this.ranges[l] - (this.inverted ? r : 0);
      if (a > e)
        break;
      let c = this.ranges[l + s], f = this.ranges[l + o], u = a + c;
      if (e <= u) {
        let h = c ? e == a ? -1 : e == u ? 1 : t : t, d = a + r + (h < 0 ? 0 : f);
        if (n)
          return d;
        let m = e == (t < 0 ? a : u) ? null : yn(l / 3, e - a), p = e == a ? Jt : e == u ? Pt : de;
        return (t < 0 ? e != a : e != u) && (p |= Dt), new st(d, p, m);
      }
      r += f - c;
    }
    return n ? e + r : new st(e + r, 0, null);
  }
  touches(e, t) {
    let n = 0, r = it(t), s = this.inverted ? 2 : 1, o = this.inverted ? 1 : 2;
    for (let l = 0; l < this.ranges.length; l += 3) {
      let a = this.ranges[l] - (this.inverted ? n : 0);
      if (a > e)
        break;
      let c = this.ranges[l + s], f = a + c;
      if (e <= f && l == r * 3)
        return !0;
      n += this.ranges[l + o] - c;
    }
    return !1;
  }
  forEach(e) {
    let t = this.inverted ? 2 : 1, n = this.inverted ? 1 : 2;
    for (let r = 0, s = 0; r < this.ranges.length; r += 3) {
      let o = this.ranges[r], l = o - (this.inverted ? s : 0), a = o + (this.inverted ? 0 : s), c = this.ranges[r + t], f = this.ranges[r + n];
      e(l, l + c, a, a + f), s += f - c;
    }
  }
  invert() {
    return new R(this.ranges, !this.inverted);
  }
  toString() {
    return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
  }
  static offset(e) {
    return e == 0 ? R.empty : new R(e < 0 ? [0, -e, 0] : [0, 0, e]);
  }
}
R.empty = new R([]);
const Ne = /* @__PURE__ */ Object.create(null);
class P {
  getMap() {
    return R.empty;
  }
  merge(e) {
    return null;
  }
  static fromJSON(e, t) {
    if (!t || !t.stepType)
      throw new RangeError("Invalid input for Step.fromJSON");
    let n = Ne[t.stepType];
    if (!n)
      throw new RangeError(`No step type ${t.stepType} defined`);
    return n.fromJSON(e, t);
  }
  static jsonID(e, t) {
    if (e in Ne)
      throw new RangeError("Duplicate use of step JSON ID " + e);
    return Ne[e] = t, t.prototype.jsonID = e, t;
  }
}
class E {
  constructor(e, t) {
    this.doc = e, this.failed = t;
  }
  static ok(e) {
    return new E(e, null);
  }
  static fail(e) {
    return new E(null, e);
  }
  static fromReplace(e, t, n, r) {
    try {
      return E.ok(e.replace(t, n, r));
    } catch (s) {
      if (s instanceof yt)
        return E.fail(s.message);
      throw s;
    }
  }
}
function Le(i, e, t) {
  let n = [];
  for (let r = 0; r < i.childCount; r++) {
    let s = i.child(r);
    s.content.size && (s = s.copy(Le(s.content, e, s))), s.isInline && (s = e(s, t, r)), n.push(s);
  }
  return g.fromArray(n);
}
class V extends P {
  constructor(e, t, n) {
    super(), this.from = e, this.to = t, this.mark = n;
  }
  apply(e) {
    let t = e.slice(this.from, this.to), n = e.resolve(this.from), r = n.node(n.sharedDepth(this.to)), s = new y(Le(t.content, (o, l) => !o.isAtom || !l.type.allowsMarkType(this.mark.type) ? o : o.mark(this.mark.addToSet(o.marks)), r), t.openStart, t.openEnd);
    return E.fromReplace(e, this.from, this.to, s);
  }
  invert() {
    return new q(this.from, this.to, this.mark);
  }
  map(e) {
    let t = e.mapResult(this.from, 1), n = e.mapResult(this.to, -1);
    return t.deleted && n.deleted || t.pos >= n.pos ? null : new V(t.pos, n.pos, this.mark);
  }
  merge(e) {
    return e instanceof V && e.mark.eq(this.mark) && this.from <= e.to && this.to >= e.from ? new V(Math.min(this.from, e.from), Math.max(this.to, e.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "addMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  static fromJSON(e, t) {
    if (typeof t.from != "number" || typeof t.to != "number")
      throw new RangeError("Invalid input for AddMarkStep.fromJSON");
    return new V(t.from, t.to, e.markFromJSON(t.mark));
  }
}
P.jsonID("addMark", V);
class q extends P {
  constructor(e, t, n) {
    super(), this.from = e, this.to = t, this.mark = n;
  }
  apply(e) {
    let t = e.slice(this.from, this.to), n = new y(Le(t.content, (r) => r.mark(this.mark.removeFromSet(r.marks)), e), t.openStart, t.openEnd);
    return E.fromReplace(e, this.from, this.to, n);
  }
  invert() {
    return new V(this.from, this.to, this.mark);
  }
  map(e) {
    let t = e.mapResult(this.from, 1), n = e.mapResult(this.to, -1);
    return t.deleted && n.deleted || t.pos >= n.pos ? null : new q(t.pos, n.pos, this.mark);
  }
  merge(e) {
    return e instanceof q && e.mark.eq(this.mark) && this.from <= e.to && this.to >= e.from ? new q(Math.min(this.from, e.from), Math.max(this.to, e.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "removeMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  static fromJSON(e, t) {
    if (typeof t.from != "number" || typeof t.to != "number")
      throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
    return new q(t.from, t.to, e.markFromJSON(t.mark));
  }
}
P.jsonID("removeMark", q);
class $ extends P {
  constructor(e, t, n, r = !1) {
    super(), this.from = e, this.to = t, this.slice = n, this.structure = r;
  }
  apply(e) {
    return this.structure && Be(e, this.from, this.to) ? E.fail("Structure replace would overwrite content") : E.fromReplace(e, this.from, this.to, this.slice);
  }
  getMap() {
    return new R([this.from, this.to - this.from, this.slice.size]);
  }
  invert(e) {
    return new $(this.from, this.from + this.slice.size, e.slice(this.from, this.to));
  }
  map(e) {
    let t = e.mapResult(this.from, 1), n = e.mapResult(this.to, -1);
    return t.deletedAcross && n.deletedAcross ? null : new $(t.pos, Math.max(t.pos, n.pos), this.slice);
  }
  merge(e) {
    if (!(e instanceof $) || e.structure || this.structure)
      return null;
    if (this.from + this.slice.size == e.from && !this.slice.openEnd && !e.slice.openStart) {
      let t = this.slice.size + e.slice.size == 0 ? y.empty : new y(this.slice.content.append(e.slice.content), this.slice.openStart, e.slice.openEnd);
      return new $(this.from, this.to + (e.to - e.from), t, this.structure);
    } else if (e.to == this.from && !this.slice.openStart && !e.slice.openEnd) {
      let t = this.slice.size + e.slice.size == 0 ? y.empty : new y(e.slice.content.append(this.slice.content), e.slice.openStart, this.slice.openEnd);
      return new $(e.from, this.to, t, this.structure);
    } else
      return null;
  }
  toJSON() {
    let e = { stepType: "replace", from: this.from, to: this.to };
    return this.slice.size && (e.slice = this.slice.toJSON()), this.structure && (e.structure = !0), e;
  }
  static fromJSON(e, t) {
    if (typeof t.from != "number" || typeof t.to != "number")
      throw new RangeError("Invalid input for ReplaceStep.fromJSON");
    return new $(t.from, t.to, y.fromJSON(e, t.slice), !!t.structure);
  }
}
P.jsonID("replace", $);
class H extends P {
  constructor(e, t, n, r, s, o, l = !1) {
    super(), this.from = e, this.to = t, this.gapFrom = n, this.gapTo = r, this.slice = s, this.insert = o, this.structure = l;
  }
  apply(e) {
    if (this.structure && (Be(e, this.from, this.gapFrom) || Be(e, this.gapTo, this.to)))
      return E.fail("Structure gap-replace would overwrite content");
    let t = e.slice(this.gapFrom, this.gapTo);
    if (t.openStart || t.openEnd)
      return E.fail("Gap is not a flat range");
    let n = this.slice.insertAt(this.insert, t.content);
    return n ? E.fromReplace(e, this.from, this.to, n) : E.fail("Content does not fit in gap");
  }
  getMap() {
    return new R([
      this.from,
      this.gapFrom - this.from,
      this.insert,
      this.gapTo,
      this.to - this.gapTo,
      this.slice.size - this.insert
    ]);
  }
  invert(e) {
    let t = this.gapTo - this.gapFrom;
    return new H(this.from, this.from + this.slice.size + t, this.from + this.insert, this.from + this.insert + t, e.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
  }
  map(e) {
    let t = e.mapResult(this.from, 1), n = e.mapResult(this.to, -1), r = e.map(this.gapFrom, -1), s = e.map(this.gapTo, 1);
    return t.deletedAcross && n.deletedAcross || r < t.pos || s > n.pos ? null : new H(t.pos, n.pos, r, s, this.slice, this.insert, this.structure);
  }
  toJSON() {
    let e = {
      stepType: "replaceAround",
      from: this.from,
      to: this.to,
      gapFrom: this.gapFrom,
      gapTo: this.gapTo,
      insert: this.insert
    };
    return this.slice.size && (e.slice = this.slice.toJSON()), this.structure && (e.structure = !0), e;
  }
  static fromJSON(e, t) {
    if (typeof t.from != "number" || typeof t.to != "number" || typeof t.gapFrom != "number" || typeof t.gapTo != "number" || typeof t.insert != "number")
      throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
    return new H(t.from, t.to, t.gapFrom, t.gapTo, y.fromJSON(e, t.slice), t.insert, !!t.structure);
  }
}
P.jsonID("replaceAround", H);
function Be(i, e, t) {
  let n = i.resolve(e), r = t - e, s = n.depth;
  for (; r > 0 && s > 0 && n.indexAfter(s) == n.node(s).childCount; )
    s--, r--;
  if (r > 0) {
    let o = n.node(s).maybeChild(n.indexAfter(s));
    for (; r > 0; ) {
      if (!o || o.isLeaf)
        return !0;
      o = o.firstChild, r--;
    }
  }
  return !1;
}
function kn(i, e, t) {
  return (e == 0 || i.canReplace(e, i.childCount)) && (t == i.childCount || i.canReplace(0, t));
}
function Sn(i) {
  let t = i.parent.content.cutByIndex(i.startIndex, i.endIndex);
  for (let n = i.depth; ; --n) {
    let r = i.$from.node(n), s = i.$from.index(n), o = i.$to.indexAfter(n);
    if (n < i.depth && r.canReplace(s, o, t))
      return n;
    if (n == 0 || r.type.spec.isolating || !kn(r, s, o))
      break;
  }
  return null;
}
function pe(i, e, t = 1, n) {
  let r = i.resolve(e), s = r.depth - t, o = n && n[n.length - 1] || r.parent;
  if (s < 0 || r.parent.type.spec.isolating || !r.parent.canReplace(r.index(), r.parent.childCount) || !o.type.validContent(r.parent.content.cutByIndex(r.index(), r.parent.childCount)))
    return !1;
  for (let c = r.depth - 1, f = t - 2; c > s; c--, f--) {
    let u = r.node(c), h = r.index(c);
    if (u.type.spec.isolating)
      return !1;
    let d = u.content.cutByIndex(h, u.childCount), m = n && n[f] || u;
    if (m != u && (d = d.replaceChild(0, m.type.create(m.attrs))), !u.canReplace(h + 1, u.childCount) || !m.type.validContent(d))
      return !1;
  }
  let l = r.indexAfter(s), a = n && n[0];
  return r.node(s).canReplaceWith(l, l, a ? a.type : r.node(s + 1).type);
}
function Lt(i, e) {
  let t = i.resolve(e), n = t.index();
  return xn(t.nodeBefore, t.nodeAfter) && t.parent.canReplace(n, n + 1);
}
function xn(i, e) {
  return !!(i && e && !i.isLeaf && i.canAppend(e));
}
let ne = class extends Error {
};
ne = function i(e) {
  let t = Error.call(this, e);
  return t.__proto__ = i.prototype, t;
};
ne.prototype = Object.create(Error.prototype);
ne.prototype.constructor = ne;
ne.prototype.name = "TransformError";
const vn = (i, e) => i.selection.empty ? !1 : (e && e(i.tr.deleteSelection().scrollIntoView()), !0), bn = (i, e, t) => {
  let { $cursor: n } = i.selection;
  if (!n || (t ? !t.endOfTextblock("backward", i) : n.parentOffset > 0))
    return !1;
  let r = Wt(n);
  if (!r) {
    let o = n.blockRange(), l = o && ie(o);
    return l == null ? !1 : (e && e(i.tr.lift(o, l).scrollIntoView()), !0);
  }
  let s = r.nodeBefore;
  if (!s.type.spec.isolating && Kt(i, r, e))
    return !0;
  if (n.parent.content.size == 0 && (U(s, "end") || x.isSelectable(s))) {
    let o = Nt(i.doc, n.before(), n.after(), y.empty);
    if (o && o.slice.size < o.to - o.from) {
      if (e) {
        let l = i.tr.step(o);
        l.setSelection(U(s, "end") ? k.findFrom(l.doc.resolve(l.mapping.map(r.pos, -1)), -1) : x.create(l.doc, r.pos - s.nodeSize)), e(l.scrollIntoView());
      }
      return !0;
    }
  }
  return s.isAtom && r.depth == n.depth - 1 ? (e && e(i.tr.delete(r.pos - s.nodeSize, r.pos).scrollIntoView()), !0) : !1;
};
function U(i, e, t = !1) {
  for (let n = i; n; n = e == "start" ? n.firstChild : n.lastChild) {
    if (n.isTextblock)
      return !0;
    if (t && n.childCount != 1)
      return !1;
  }
  return !1;
}
const Mn = (i, e, t) => {
  let { $head: n, empty: r } = i.selection, s = n;
  if (!r)
    return !1;
  if (n.parent.isTextblock) {
    if (t ? !t.endOfTextblock("backward", i) : n.parentOffset > 0)
      return !1;
    s = Wt(n);
  }
  let o = s && s.nodeBefore;
  return !o || !x.isSelectable(o) ? !1 : (e && e(i.tr.setSelection(x.create(i.doc, s.pos - o.nodeSize)).scrollIntoView()), !0);
};
function Wt(i) {
  if (!i.parent.type.spec.isolating)
    for (let e = i.depth - 1; e >= 0; e--) {
      if (i.index(e) > 0)
        return i.doc.resolve(i.before(e + 1));
      if (i.node(e).type.spec.isolating)
        break;
    }
  return null;
}
const Cn = (i, e, t) => {
  let { $cursor: n } = i.selection;
  if (!n || (t ? !t.endOfTextblock("forward", i) : n.parentOffset < n.parent.content.size))
    return !1;
  let r = Vt(n);
  if (!r)
    return !1;
  let s = r.nodeAfter;
  if (Kt(i, r, e))
    return !0;
  if (n.parent.content.size == 0 && (U(s, "start") || x.isSelectable(s))) {
    let o = Nt(i.doc, n.before(), n.after(), y.empty);
    if (o && o.slice.size < o.to - o.from) {
      if (e) {
        let l = i.tr.step(o);
        l.setSelection(U(s, "start") ? k.findFrom(l.doc.resolve(l.mapping.map(r.pos)), 1) : x.create(l.doc, l.mapping.map(r.pos))), e(l.scrollIntoView());
      }
      return !0;
    }
  }
  return s.isAtom && r.depth == n.depth - 1 ? (e && e(i.tr.delete(r.pos, r.pos + s.nodeSize).scrollIntoView()), !0) : !1;
}, In = (i, e, t) => {
  let { $head: n, empty: r } = i.selection, s = n;
  if (!r)
    return !1;
  if (n.parent.isTextblock) {
    if (t ? !t.endOfTextblock("forward", i) : n.parentOffset < n.parent.content.size)
      return !1;
    s = Vt(n);
  }
  let o = s && s.nodeAfter;
  return !o || !x.isSelectable(o) ? !1 : (e && e(i.tr.setSelection(x.create(i.doc, s.pos)).scrollIntoView()), !0);
};
function Vt(i) {
  if (!i.parent.type.spec.isolating)
    for (let e = i.depth - 1; e >= 0; e--) {
      let t = i.node(e);
      if (i.index(e) + 1 < t.childCount)
        return i.doc.resolve(i.after(e + 1));
      if (t.type.spec.isolating)
        break;
    }
  return null;
}
const En = (i, e) => {
  let { $from: t, $to: n } = i.selection, r = t.blockRange(n), s = r && ie(r);
  return s == null ? !1 : (e && e(i.tr.lift(r, s).scrollIntoView()), !0);
}, Tn = (i, e) => {
  let { $head: t, $anchor: n } = i.selection;
  return !t.parent.type.spec.code || !t.sameParent(n) ? !1 : (e && e(i.tr.insertText(`
`).scrollIntoView()), !0);
};
function qt(i) {
  for (let e = 0; e < i.edgeCount; e++) {
    let { type: t } = i.edge(e);
    if (t.isTextblock && !t.hasRequiredAttrs())
      return t;
  }
  return null;
}
const On = (i, e) => {
  let { $head: t, $anchor: n } = i.selection;
  if (!t.parent.type.spec.code || !t.sameParent(n))
    return !1;
  let r = t.node(-1), s = t.indexAfter(-1), o = qt(r.contentMatchAt(s));
  if (!o || !r.canReplaceWith(s, s, o))
    return !1;
  if (e) {
    let l = t.after(), a = i.tr.replaceWith(l, l, o.createAndFill());
    a.setSelection(k.near(a.doc.resolve(l), 1)), e(a.scrollIntoView());
  }
  return !0;
}, Nn = (i, e) => {
  let t = i.selection, { $from: n, $to: r } = t;
  if (t instanceof F || n.parent.inlineContent || r.parent.inlineContent)
    return !1;
  let s = qt(r.parent.contentMatchAt(r.indexAfter()));
  if (!s || !s.isTextblock)
    return !1;
  if (e) {
    let o = (!n.parentOffset && r.index() < r.parent.childCount ? n : r).pos, l = i.tr.insert(o, s.createAndFill());
    l.setSelection(v.create(l.doc, o + 1)), e(l.scrollIntoView());
  }
  return !0;
}, An = (i, e) => {
  let { $cursor: t } = i.selection;
  if (!t || t.parent.content.size)
    return !1;
  if (t.depth > 1 && t.after() != t.end(-1)) {
    let s = t.before();
    if (Tt(i.doc, s))
      return e && e(i.tr.split(s).scrollIntoView()), !0;
  }
  let n = t.blockRange(), r = n && ie(n);
  return r == null ? !1 : (e && e(i.tr.lift(n, r).scrollIntoView()), !0);
}, Rn = (i, e) => {
  let { $from: t, to: n } = i.selection, r, s = t.sharedDepth(n);
  return s == 0 ? !1 : (r = t.before(s), e && e(i.tr.setSelection(x.create(i.doc, r))), !0);
};
function zn(i, e, t) {
  let n = e.nodeBefore, r = e.nodeAfter, s = e.index();
  return !n || !r || !n.type.compatibleContent(r.type) ? !1 : !n.content.size && e.parent.canReplace(s - 1, s) ? (t && t(i.tr.delete(e.pos - n.nodeSize, e.pos).scrollIntoView()), !0) : !e.parent.canReplace(s, s + 1) || !(r.isTextblock || Ot(i.doc, e.pos)) ? !1 : (t && t(i.tr.clearIncompatible(e.pos, n.type, n.contentMatchAt(n.childCount)).join(e.pos).scrollIntoView()), !0);
}
function Kt(i, e, t) {
  let n = e.nodeBefore, r = e.nodeAfter, s, o;
  if (n.type.spec.isolating || r.type.spec.isolating)
    return !1;
  if (zn(i, e, t))
    return !0;
  let l = e.parent.canReplace(e.index(), e.index() + 1);
  if (l && (s = (o = n.contentMatchAt(n.childCount)).findWrapping(r.type)) && o.matchType(s[0] || r.type).validEnd) {
    if (t) {
      let u = e.pos + r.nodeSize, h = g.empty;
      for (let p = s.length - 1; p >= 0; p--)
        h = g.from(s[p].create(null, h));
      h = g.from(n.copy(h));
      let d = i.tr.step(new T(e.pos - 1, u, e.pos, u, new y(h, 1, 0), s.length, !0)), m = u + 2 * s.length;
      Ot(d.doc, m) && d.join(m), t(d.scrollIntoView());
    }
    return !0;
  }
  let a = k.findFrom(e, 1), c = a && a.$from.blockRange(a.$to), f = c && ie(c);
  if (f != null && f >= e.depth)
    return t && t(i.tr.lift(c, f).scrollIntoView()), !0;
  if (l && U(r, "start", !0) && U(n, "end")) {
    let u = n, h = [];
    for (; h.push(u), !u.isTextblock; )
      u = u.lastChild;
    let d = r, m = 1;
    for (; !d.isTextblock; d = d.firstChild)
      m++;
    if (u.canReplace(u.childCount, u.childCount, d.content)) {
      if (t) {
        let p = g.empty;
        for (let S = h.length - 1; S >= 0; S--)
          p = g.from(h[S].copy(p));
        let w = i.tr.step(new T(e.pos - h.length, e.pos + r.nodeSize, e.pos + m, e.pos + r.nodeSize - m, new y(p, h.length, 0), 0, !0));
        t(w.scrollIntoView());
      }
      return !0;
    }
  }
  return !1;
}
function Gt(i) {
  return function(e, t) {
    let n = e.selection, r = i < 0 ? n.$from : n.$to, s = r.depth;
    for (; r.node(s).isInline; ) {
      if (!s)
        return !1;
      s--;
    }
    return r.node(s).isTextblock ? (t && t(e.tr.setSelection(v.create(e.doc, i < 0 ? r.start(s) : r.end(s)))), !0) : !1;
  };
}
const Fn = Gt(-1), Bn = Gt(1);
function $n(i, e = null) {
  return function(t, n) {
    let { $from: r, $to: s } = t.selection, o = r.blockRange(s), l = o && Et(o, i, e);
    return l ? (n && n(t.tr.wrap(o, l).scrollIntoView()), !0) : !1;
  };
}
function ot(i, e = null) {
  return function(t, n) {
    let { from: r, to: s } = t.selection, o = !1;
    return t.doc.nodesBetween(r, s, (l, a) => {
      if (o)
        return !1;
      if (!(!l.isTextblock || l.hasMarkup(i, e)))
        if (l.type == i)
          o = !0;
        else {
          let c = t.doc.resolve(a), f = c.index();
          o = c.parent.canReplaceWith(f, f + 1, i);
        }
    }), o ? (n && n(t.tr.setBlockType(r, s, i, e).scrollIntoView()), !0) : !1;
  };
}
typeof navigator < "u" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : typeof os < "u" && os.platform && os.platform() == "darwin";
function Pn(i, e = null) {
  return function(t, n) {
    let { $from: r, $to: s } = t.selection, o = r.blockRange(s), l = !1, a = o;
    if (!o)
      return !1;
    if (o.depth >= 2 && r.node(o.depth - 1).type.compatibleContent(i) && o.startIndex == 0) {
      if (r.index(o.depth - 1) == 0)
        return !1;
      let f = t.doc.resolve(o.start - 2);
      a = new ze(f, f, o.depth), o.endIndex < o.parent.childCount && (o = new ze(r, t.doc.resolve(s.end(o.depth)), o.depth)), l = !0;
    }
    let c = Et(a, i, e, o);
    return c ? (n && n(Jn(t.tr, o, c, l, i).scrollIntoView()), !0) : !1;
  };
}
function Jn(i, e, t, n, r) {
  let s = g.empty;
  for (let f = t.length - 1; f >= 0; f--)
    s = g.from(t[f].type.create(t[f].attrs, s));
  i.step(new T(e.start - (n ? 2 : 0), e.end, e.start, e.end, new y(s, 0, 0), t.length, !0));
  let o = 0;
  for (let f = 0; f < t.length; f++)
    t[f].type == r && (o = f + 1);
  let l = t.length - o, a = e.start + t.length - (n ? 2 : 0), c = e.parent;
  for (let f = e.startIndex, u = e.endIndex, h = !0; f < u; f++, h = !1)
    !h && Tt(i.doc, a, l) && (i.split(a, l), a += 2 * l), a += c.child(f).nodeSize;
  return i;
}
function Dn(i) {
  return function(e, t) {
    let { $from: n, $to: r } = e.selection, s = n.blockRange(r, (o) => o.childCount > 0 && o.firstChild.type == i);
    return s ? t ? n.node(s.depth - 1).type == i ? Ln(e, t, i, s) : Wn(e, t, s) : !0 : !1;
  };
}
function Ln(i, e, t, n) {
  let r = i.tr, s = n.end, o = n.$to.end(n.depth);
  return s < o && (r.step(new T(s - 1, o, s, o, new y(g.from(t.create(null, n.parent.copy())), 1, 0), 1, !0)), n = new ze(r.doc.resolve(n.$from.pos), r.doc.resolve(o), n.depth)), e(r.lift(n, ie(n)).scrollIntoView()), !0;
}
function Wn(i, e, t) {
  let n = i.tr, r = t.parent;
  for (let d = t.end, m = t.endIndex - 1, p = t.startIndex; m > p; m--)
    d -= r.child(m).nodeSize, n.delete(d - 1, d + 1);
  let s = n.doc.resolve(t.start), o = s.nodeAfter;
  if (n.mapping.map(t.end) != t.start + s.nodeAfter.nodeSize)
    return !1;
  let l = t.startIndex == 0, a = t.endIndex == r.childCount, c = s.node(-1), f = s.index(-1);
  if (!c.canReplace(f + (l ? 0 : 1), f + 1, o.content.append(a ? g.empty : g.from(r))))
    return !1;
  let u = s.pos, h = u + o.nodeSize;
  return n.step(new T(u - (l ? 1 : 0), h + (a ? 1 : 0), u + 1, h - 1, new y((l ? g.empty : g.from(r.copy(g.empty))).append(a ? g.empty : g.from(r.copy(g.empty))), l ? 0 : 1, a ? 0 : 1), l ? 0 : 1)), e(n.scrollIntoView()), !0;
}
function Vn(i) {
  return function(e, t) {
    let { $from: n, $to: r } = e.selection, s = n.blockRange(r, (c) => c.childCount > 0 && c.firstChild.type == i);
    if (!s)
      return !1;
    let o = s.startIndex;
    if (o == 0)
      return !1;
    let l = s.parent, a = l.child(o - 1);
    if (a.type != i)
      return !1;
    if (t) {
      let c = a.lastChild && a.lastChild.type == l.type, f = g.from(c ? i.create() : null), u = new y(g.from(i.create(null, g.from(l.type.create(null, f)))), c ? 3 : 1, 0), h = s.start, d = s.end;
      t(e.tr.step(new T(h - (c ? 3 : 1), d, h, d, u, 1, !0)).scrollIntoView());
    }
    return !0;
  };
}
function jt(i) {
  const { state: e, transaction: t } = i;
  let { selection: n } = t, { doc: r } = t, { storedMarks: s } = t;
  return {
    ...e,
    apply: e.apply.bind(e),
    applyTransaction: e.applyTransaction.bind(e),
    filterTransaction: e.filterTransaction,
    plugins: e.plugins,
    schema: e.schema,
    reconfigure: e.reconfigure.bind(e),
    toJSON: e.toJSON.bind(e),
    get storedMarks() {
      return s;
    },
    get selection() {
      return n;
    },
    get doc() {
      return r;
    },
    get tr() {
      return n = t.selection, r = t.doc, s = t.storedMarks, t;
    }
  };
}
class qn {
  constructor(e) {
    this.editor = e.editor, this.rawCommands = this.editor.extensionManager.commands, this.customState = e.state;
  }
  get hasCustomState() {
    return !!this.customState;
  }
  get state() {
    return this.customState || this.editor.state;
  }
  get commands() {
    const { rawCommands: e, editor: t, state: n } = this, { view: r } = t, { tr: s } = n, o = this.buildProps(s);
    return Object.fromEntries(Object.entries(e).map(([l, a]) => [l, (...f) => {
      const u = a(...f)(o);
      return !s.getMeta("preventDispatch") && !this.hasCustomState && r.dispatch(s), u;
    }]));
  }
  get chain() {
    return () => this.createChain();
  }
  get can() {
    return () => this.createCan();
  }
  createChain(e, t = !0) {
    const { rawCommands: n, editor: r, state: s } = this, { view: o } = r, l = [], a = !!e, c = e || s.tr, f = () => (!a && t && !c.getMeta("preventDispatch") && !this.hasCustomState && o.dispatch(c), l.every((h) => h === !0)), u = {
      ...Object.fromEntries(Object.entries(n).map(([h, d]) => [h, (...p) => {
        const w = this.buildProps(c, t), S = d(...p)(w);
        return l.push(S), u;
      }])),
      run: f
    };
    return u;
  }
  createCan(e) {
    const { rawCommands: t, state: n } = this, r = !1, s = e || n.tr, o = this.buildProps(s, r);
    return {
      ...Object.fromEntries(Object.entries(t).map(([a, c]) => [a, (...f) => c(...f)({ ...o, dispatch: void 0 })])),
      chain: () => this.createChain(s, r)
    };
  }
  buildProps(e, t = !0) {
    const { rawCommands: n, editor: r, state: s } = this, { view: o } = r;
    s.storedMarks && e.setStoredMarks(s.storedMarks);
    const l = {
      tr: e,
      editor: r,
      view: o,
      state: jt({
        state: s,
        transaction: e
      }),
      dispatch: t ? () => {
      } : void 0,
      chain: () => this.createChain(e),
      can: () => this.createCan(e),
      get commands() {
        return Object.fromEntries(Object.entries(n).map(([a, c]) => [a, (...f) => c(...f)(l)]));
      }
    };
    return l;
  }
}
function I(i, e, t) {
  return i.config[e] === void 0 && i.parent ? I(i.parent, e, t) : typeof i.config[e] == "function" ? i.config[e].bind({
    ...t,
    parent: i.parent ? I(i.parent, e, t) : null
  }) : i.config[e];
}
function Kn(i) {
  const e = i.filter((r) => r.type === "extension"), t = i.filter((r) => r.type === "node"), n = i.filter((r) => r.type === "mark");
  return {
    baseExtensions: e,
    nodeExtensions: t,
    markExtensions: n
  };
}
function M(i, e) {
  if (typeof i == "string") {
    if (!e.nodes[i])
      throw Error(`There is no node type named '${i}'. Maybe you forgot to add the extension?`);
    return e.nodes[i];
  }
  return i;
}
function Ht(...i) {
  return i.filter((e) => !!e).reduce((e, t) => {
    const n = { ...e };
    return Object.entries(t).forEach(([r, s]) => {
      if (!n[r]) {
        n[r] = s;
        return;
      }
      r === "class" ? n[r] = [n[r], s].join(" ") : r === "style" ? n[r] = [n[r], s].join("; ") : n[r] = s;
    }), n;
  }, {});
}
function Gn(i) {
  return typeof i == "function";
}
function z(i, e = void 0, ...t) {
  return Gn(i) ? e ? i.bind(e)(...t) : i(...t) : i;
}
function jn(i) {
  return Object.prototype.toString.call(i) === "[object RegExp]";
}
function Hn(i) {
  return Object.prototype.toString.call(i).slice(8, -1);
}
function Ae(i) {
  return Hn(i) !== "Object" ? !1 : i.constructor === Object && Object.getPrototypeOf(i) === Object.prototype;
}
function We(i, e) {
  const t = { ...i };
  return Ae(i) && Ae(e) && Object.keys(e).forEach((n) => {
    Ae(e[n]) ? n in i ? t[n] = We(i[n], e[n]) : Object.assign(t, { [n]: e[n] }) : Object.assign(t, { [n]: e[n] });
  }), t;
}
class B {
  constructor(e = {}) {
    this.type = "extension", this.name = "extension", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...e
    }, this.name = this.config.name, e.defaultOptions && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = z(I(this, "addOptions", {
      name: this.name
    }))), this.storage = z(I(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(e = {}) {
    return new B(e);
  }
  configure(e = {}) {
    const t = this.extend();
    return t.options = We(this.options, e), t.storage = z(I(t, "addStorage", {
      name: t.name,
      options: t.options
    })), t;
  }
  extend(e = {}) {
    const t = new B(e);
    return t.parent = this, this.child = t, t.name = e.name ? e.name : t.parent.name, e.defaultOptions && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${t.name}".`), t.options = z(I(t, "addOptions", {
      name: t.name
    })), t.storage = z(I(t, "addStorage", {
      name: t.name,
      options: t.options
    })), t;
  }
}
function Un(i, e, t) {
  const { from: n, to: r } = e, { blockSeparator: s = `

`, textSerializers: o = {} } = t || {};
  let l = "", a = !0;
  return i.nodesBetween(n, r, (c, f, u, h) => {
    var d;
    const m = o == null ? void 0 : o[c.type.name];
    m ? (c.isBlock && !a && (l += s, a = !0), u && (l += m({
      node: c,
      pos: f,
      parent: u,
      index: h,
      range: e
    }))) : c.isText ? (l += (d = c == null ? void 0 : c.text) === null || d === void 0 ? void 0 : d.slice(Math.max(n, f) - f, r - f), a = !1) : c.isBlock && !a && (l += s, a = !0);
  }), l;
}
function Qn(i) {
  return Object.fromEntries(Object.entries(i.nodes).filter(([, e]) => e.spec.toText).map(([e, t]) => [e, t.spec.toText]));
}
B.create({
  name: "clipboardTextSerializer",
  addProseMirrorPlugins() {
    return [
      new se({
        key: new oe("clipboardTextSerializer"),
        props: {
          clipboardTextSerializer: () => {
            const { editor: i } = this, { state: e, schema: t } = i, { doc: n, selection: r } = e, { ranges: s } = r, o = Math.min(...s.map((f) => f.$from.pos)), l = Math.max(...s.map((f) => f.$to.pos)), a = Qn(t);
            return Un(n, { from: o, to: l }, {
              textSerializers: a
            });
          }
        }
      })
    ];
  }
});
const Xn = () => ({ editor: i, view: e }) => (requestAnimationFrame(() => {
  var t;
  i.isDestroyed || (e.dom.blur(), (t = window == null ? void 0 : window.getSelection()) === null || t === void 0 || t.removeAllRanges());
}), !0), Yn = (i = !1) => ({ commands: e }) => e.setContent("", i), Zn = () => ({ state: i, tr: e, dispatch: t }) => {
  const { selection: n } = e, { ranges: r } = n;
  return t && r.forEach(({ $from: s, $to: o }) => {
    i.doc.nodesBetween(s.pos, o.pos, (l, a) => {
      if (l.type.isText)
        return;
      const { doc: c, mapping: f } = e, u = c.resolve(f.map(a)), h = c.resolve(f.map(a + l.nodeSize)), d = u.blockRange(h);
      if (!d)
        return;
      const m = Sn(d);
      if (l.type.isTextblock) {
        const { defaultType: p } = u.parent.contentMatchAt(u.index());
        e.setNodeMarkup(d.start, p);
      }
      (m || m === 0) && e.lift(d, m);
    });
  }), !0;
}, _n = (i) => (e) => i(e), er = () => ({ state: i, dispatch: e }) => Nn(i, e), tr = (i) => ({ tr: e, state: t, dispatch: n }) => {
  const r = M(i, t.schema), s = e.selection.$anchor;
  for (let o = s.depth; o > 0; o -= 1)
    if (s.node(o).type === r) {
      if (n) {
        const a = s.before(o), c = s.after(o);
        e.delete(a, c).scrollIntoView();
      }
      return !0;
    }
  return !1;
}, nr = (i) => ({ tr: e, dispatch: t }) => {
  const { from: n, to: r } = i;
  return t && e.delete(n, r), !0;
}, rr = () => ({ state: i, dispatch: e }) => vn(i, e), ir = () => ({ commands: i }) => i.keyboardShortcut("Enter"), sr = () => ({ state: i, dispatch: e }) => On(i, e);
function ke(i, e, t = { strict: !0 }) {
  const n = Object.keys(e);
  return n.length ? n.every((r) => t.strict ? e[r] === i[r] : jn(e[r]) ? e[r].test(i[r]) : e[r] === i[r]) : !0;
}
function $e(i, e, t = {}) {
  return i.find((n) => n.type === e && ke(n.attrs, t));
}
function or(i, e, t = {}) {
  return !!$e(i, e, t);
}
function Ut(i, e, t = {}) {
  if (!i || !e)
    return;
  let n = i.parent.childAfter(i.parentOffset);
  if (i.parentOffset === n.offset && n.offset !== 0 && (n = i.parent.childBefore(i.parentOffset)), !n.node)
    return;
  const r = $e([...n.node.marks], e, t);
  if (!r)
    return;
  let s = n.index, o = i.start() + n.offset, l = s + 1, a = o + n.node.nodeSize;
  for ($e([...n.node.marks], e, t); s > 0 && r.isInSet(i.parent.child(s - 1).marks); )
    s -= 1, o -= i.parent.child(s).nodeSize;
  for (; l < i.parent.childCount && or([...i.parent.child(l).marks], e, t); )
    a += i.parent.child(l).nodeSize, l += 1;
  return {
    from: o,
    to: a
  };
}
function J(i, e) {
  if (typeof i == "string") {
    if (!e.marks[i])
      throw Error(`There is no mark type named '${i}'. Maybe you forgot to add the extension?`);
    return e.marks[i];
  }
  return i;
}
const lr = (i, e = {}) => ({ tr: t, state: n, dispatch: r }) => {
  const s = J(i, n.schema), { doc: o, selection: l } = t, { $from: a, from: c, to: f } = l;
  if (r) {
    const u = Ut(a, s, e);
    if (u && u.from <= c && u.to >= f) {
      const h = v.create(o, u.from, u.to);
      t.setSelection(h);
    }
  }
  return !0;
}, ar = (i) => (e) => {
  const t = typeof i == "function" ? i(e) : i;
  for (let n = 0; n < t.length; n += 1)
    if (t[n](e))
      return !0;
  return !1;
};
function cr(i) {
  return i instanceof v;
}
function K(i = 0, e = 0, t = 0) {
  return Math.min(Math.max(i, e), t);
}
function fr(i, e = null) {
  if (!e)
    return null;
  const t = k.atStart(i), n = k.atEnd(i);
  if (e === "start" || e === !0)
    return t;
  if (e === "end")
    return n;
  const r = t.from, s = n.to;
  return e === "all" ? v.create(i, K(0, r, s), K(i.content.size, r, s)) : v.create(i, K(e, r, s), K(e, r, s));
}
function Ve() {
  return [
    "iPad Simulator",
    "iPhone Simulator",
    "iPod Simulator",
    "iPad",
    "iPhone",
    "iPod"
  ].includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document;
}
const ur = (i = null, e = {}) => ({ editor: t, view: n, tr: r, dispatch: s }) => {
  e = {
    scrollIntoView: !0,
    ...e
  };
  const o = () => {
    Ve() && n.dom.focus(), requestAnimationFrame(() => {
      t.isDestroyed || (n.focus(), e != null && e.scrollIntoView && t.commands.scrollIntoView());
    });
  };
  if (n.hasFocus() && i === null || i === !1)
    return !0;
  if (s && i === null && !cr(t.state.selection))
    return o(), !0;
  const l = fr(r.doc, i) || t.state.selection, a = t.state.selection.eq(l);
  return s && (a || r.setSelection(l), a && r.storedMarks && r.setStoredMarks(r.storedMarks), o()), !0;
}, hr = (i, e) => (t) => i.every((n, r) => e(n, { ...t, index: r })), dr = (i, e) => ({ tr: t, commands: n }) => n.insertContentAt({ from: t.selection.from, to: t.selection.to }, i, e);
function lt(i) {
  const e = `<body>${i}</body>`;
  return new window.DOMParser().parseFromString(e, "text/html").body;
}
function Se(i, e, t) {
  if (t = {
    slice: !0,
    parseOptions: {},
    ...t
  }, typeof i == "object" && i !== null)
    try {
      return Array.isArray(i) ? g.fromArray(i.map((n) => e.nodeFromJSON(n))) : e.nodeFromJSON(i);
    } catch (n) {
      return console.warn("[tiptap warn]: Invalid content.", "Passed value:", i, "Error:", n), Se("", e, t);
    }
  if (typeof i == "string") {
    const n = ge.fromSchema(e);
    return t.slice ? n.parseSlice(lt(i), t.parseOptions).content : n.parse(lt(i), t.parseOptions);
  }
  return Se("", e, t);
}
function pr(i, e, t) {
  const n = i.steps.length - 1;
  if (n < e)
    return;
  const r = i.steps[n];
  if (!(r instanceof $ || r instanceof H))
    return;
  const s = i.mapping.maps[n];
  let o = 0;
  s.forEach((l, a, c, f) => {
    o === 0 && (o = f);
  }), i.setSelection(k.near(i.doc.resolve(o), t));
}
const mr = (i) => i.toString().startsWith("<"), gr = (i, e, t) => ({ tr: n, dispatch: r, editor: s }) => {
  if (r) {
    t = {
      parseOptions: {},
      updateSelection: !0,
      ...t
    };
    const o = Se(e, s.schema, {
      parseOptions: {
        preserveWhitespace: "full",
        ...t.parseOptions
      }
    });
    if (o.toString() === "<>")
      return !0;
    let { from: l, to: a } = typeof i == "number" ? { from: i, to: i } : i, c = !0, f = !0;
    if ((mr(o) ? o : [o]).forEach((h) => {
      h.check(), c = c ? h.isText && h.marks.length === 0 : !1, f = f ? h.isBlock : !1;
    }), l === a && f) {
      const { parent: h } = n.doc.resolve(l);
      h.isTextblock && !h.type.spec.code && !h.childCount && (l -= 1, a += 1);
    }
    c ? n.insertText(e, l, a) : n.replaceWith(l, a, o), t.updateSelection && pr(n, n.steps.length - 1, -1);
  }
  return !0;
}, yr = () => ({ state: i, dispatch: e }) => bn(i, e), wr = () => ({ state: i, dispatch: e }) => Cn(i, e);
function Qt() {
  return typeof navigator < "u" ? /Mac/.test(navigator.platform) : !1;
}
function kr(i) {
  const e = i.split(/-(?!$)/);
  let t = e[e.length - 1];
  t === "Space" && (t = " ");
  let n, r, s, o;
  for (let l = 0; l < e.length - 1; l += 1) {
    const a = e[l];
    if (/^(cmd|meta|m)$/i.test(a))
      o = !0;
    else if (/^a(lt)?$/i.test(a))
      n = !0;
    else if (/^(c|ctrl|control)$/i.test(a))
      r = !0;
    else if (/^s(hift)?$/i.test(a))
      s = !0;
    else if (/^mod$/i.test(a))
      Ve() || Qt() ? o = !0 : r = !0;
    else
      throw new Error(`Unrecognized modifier name: ${a}`);
  }
  return n && (t = `Alt-${t}`), r && (t = `Ctrl-${t}`), o && (t = `Meta-${t}`), s && (t = `Shift-${t}`), t;
}
const Sr = (i) => ({ editor: e, view: t, tr: n, dispatch: r }) => {
  const s = kr(i).split(/-(?!$)/), o = s.find((c) => !["Alt", "Ctrl", "Meta", "Shift"].includes(c)), l = new KeyboardEvent("keydown", {
    key: o === "Space" ? " " : o,
    altKey: s.includes("Alt"),
    ctrlKey: s.includes("Ctrl"),
    metaKey: s.includes("Meta"),
    shiftKey: s.includes("Shift"),
    bubbles: !0,
    cancelable: !0
  }), a = e.captureTransaction(() => {
    t.someProp("handleKeyDown", (c) => c(t, l));
  });
  return a == null || a.steps.forEach((c) => {
    const f = c.map(n.mapping);
    f && r && n.maybeStep(f);
  }), !0;
};
function qe(i, e, t = {}) {
  const { from: n, to: r, empty: s } = i.selection, o = e ? M(e, i.schema) : null, l = [];
  i.doc.nodesBetween(n, r, (u, h) => {
    if (u.isText)
      return;
    const d = Math.max(n, h), m = Math.min(r, h + u.nodeSize);
    l.push({
      node: u,
      from: d,
      to: m
    });
  });
  const a = r - n, c = l.filter((u) => o ? o.name === u.node.type.name : !0).filter((u) => ke(u.node.attrs, t, { strict: !1 }));
  return s ? !!c.length : c.reduce((u, h) => u + h.to - h.from, 0) >= a;
}
const xr = (i, e = {}) => ({ state: t, dispatch: n }) => {
  const r = M(i, t.schema);
  return qe(t, r, e) ? En(t, n) : !1;
}, vr = () => ({ state: i, dispatch: e }) => An(i, e), br = (i) => ({ state: e, dispatch: t }) => {
  const n = M(i, e.schema);
  return Dn(n)(e, t);
}, Mr = () => ({ state: i, dispatch: e }) => Tn(i, e);
function Xt(i, e) {
  return e.nodes[i] ? "node" : e.marks[i] ? "mark" : null;
}
function at(i, e) {
  const t = typeof e == "string" ? [e] : e;
  return Object.keys(i).reduce((n, r) => (t.includes(r) || (n[r] = i[r]), n), {});
}
const Cr = (i, e) => ({ tr: t, state: n, dispatch: r }) => {
  let s = null, o = null;
  const l = Xt(typeof i == "string" ? i : i.name, n.schema);
  return l ? (l === "node" && (s = M(i, n.schema)), l === "mark" && (o = J(i, n.schema)), r && t.selection.ranges.forEach((a) => {
    n.doc.nodesBetween(a.$from.pos, a.$to.pos, (c, f) => {
      s && s === c.type && t.setNodeMarkup(f, void 0, at(c.attrs, e)), o && c.marks.length && c.marks.forEach((u) => {
        o === u.type && t.addMark(f, f + c.nodeSize, o.create(at(u.attrs, e)));
      });
    });
  }), !0) : !1;
}, Ir = () => ({ tr: i, dispatch: e }) => (e && i.scrollIntoView(), !0), Er = () => ({ tr: i, commands: e }) => e.setTextSelection({
  from: 0,
  to: i.doc.content.size
}), Tr = () => ({ state: i, dispatch: e }) => Mn(i, e), Or = () => ({ state: i, dispatch: e }) => In(i, e), Nr = () => ({ state: i, dispatch: e }) => Rn(i, e), Ar = () => ({ state: i, dispatch: e }) => Bn(i, e), Rr = () => ({ state: i, dispatch: e }) => Fn(i, e);
function zr(i, e, t = {}) {
  return Se(i, e, { slice: !1, parseOptions: t });
}
const Fr = (i, e = !1, t = {}) => ({ tr: n, editor: r, dispatch: s }) => {
  const { doc: o } = n, l = zr(i, r.schema, t);
  return s && n.replaceWith(0, o.content.size, l).setMeta("preventUpdate", !e), !0;
};
function Br(i, e) {
  const t = J(e, i.schema), { from: n, to: r, empty: s } = i.selection, o = [];
  s ? (i.storedMarks && o.push(...i.storedMarks), o.push(...i.selection.$head.marks())) : i.doc.nodesBetween(n, r, (a) => {
    o.push(...a.marks);
  });
  const l = o.find((a) => a.type.name === t.name);
  return l ? { ...l.attrs } : {};
}
const $r = (i, e = {}) => ({ tr: t, state: n, dispatch: r }) => {
  const { selection: s } = t, { empty: o, ranges: l } = s, a = J(i, n.schema);
  if (r)
    if (o) {
      const c = Br(n, a);
      t.addStoredMark(a.create({
        ...c,
        ...e
      }));
    } else
      l.forEach((c) => {
        const f = c.$from.pos, u = c.$to.pos;
        n.doc.nodesBetween(f, u, (h, d) => {
          const m = Math.max(d, f), p = Math.min(d + h.nodeSize, u);
          h.marks.find((S) => S.type === a) ? h.marks.forEach((S) => {
            a === S.type && t.addMark(m, p, a.create({
              ...S.attrs,
              ...e
            }));
          }) : t.addMark(m, p, a.create(e));
        });
      });
  return !0;
}, Pr = (i, e) => ({ tr: t }) => (t.setMeta(i, e), !0), Jr = (i, e = {}) => ({ state: t, dispatch: n, chain: r }) => {
  const s = M(i, t.schema);
  return s.isTextblock ? r().command(({ commands: o }) => ot(s, e)(t) ? !0 : o.clearNodes()).command(({ state: o }) => ot(s, e)(o, n)).run() : (console.warn('[tiptap warn]: Currently "setNode()" only supports text block nodes.'), !1);
}, Dr = (i) => ({ tr: e, dispatch: t }) => {
  if (t) {
    const { doc: n } = e, r = K(i, 0, n.content.size), s = x.create(n, r);
    e.setSelection(s);
  }
  return !0;
}, Lr = (i) => ({ tr: e, dispatch: t }) => {
  if (t) {
    const { doc: n } = e, { from: r, to: s } = typeof i == "number" ? { from: i, to: i } : i, o = v.atStart(n).from, l = v.atEnd(n).to, a = K(r, o, l), c = K(s, o, l), f = v.create(n, a, c);
    e.setSelection(f);
  }
  return !0;
}, Wr = (i) => ({ state: e, dispatch: t }) => {
  const n = M(i, e.schema);
  return Vn(n)(e, t);
};
function Vr(i) {
  for (let e = 0; e < i.edgeCount; e += 1) {
    const { type: t } = i.edge(e);
    if (t.isTextblock && !t.hasRequiredAttrs())
      return t;
  }
  return null;
}
function me(i, e, t) {
  return Object.fromEntries(Object.entries(t).filter(([n]) => {
    const r = i.find((s) => s.type === e && s.name === n);
    return r ? r.attribute.keepOnSplit : !1;
  }));
}
function ct(i, e) {
  const t = i.storedMarks || i.selection.$to.parentOffset && i.selection.$from.marks();
  if (t) {
    const n = t.filter((r) => e == null ? void 0 : e.includes(r.type.name));
    i.tr.ensureMarks(n);
  }
}
const qr = ({ keepMarks: i = !0 } = {}) => ({ tr: e, state: t, dispatch: n, editor: r }) => {
  const { selection: s, doc: o } = e, { $from: l, $to: a } = s, c = r.extensionManager.attributes, f = me(c, l.node().type.name, l.node().attrs);
  if (s instanceof x && s.node.isBlock)
    return !l.parentOffset || !pe(o, l.pos) ? !1 : (n && (i && ct(t, r.extensionManager.splittableMarks), e.split(l.pos).scrollIntoView()), !0);
  if (!l.parent.isBlock)
    return !1;
  if (n) {
    const u = a.parentOffset === a.parent.content.size;
    s instanceof v && e.deleteSelection();
    const h = l.depth === 0 ? void 0 : Vr(l.node(-1).contentMatchAt(l.indexAfter(-1)));
    let d = u && h ? [{
      type: h,
      attrs: f
    }] : void 0, m = pe(e.doc, e.mapping.map(l.pos), 1, d);
    if (!d && !m && pe(e.doc, e.mapping.map(l.pos), 1, h ? [{ type: h }] : void 0) && (m = !0, d = h ? [{
      type: h,
      attrs: f
    }] : void 0), m && (e.split(e.mapping.map(l.pos), 1, d), h && !u && !l.parentOffset && l.parent.type !== h)) {
      const p = e.mapping.map(l.before()), w = e.doc.resolve(p);
      l.node(-1).canReplaceWith(w.index(), w.index() + 1, h) && e.setNodeMarkup(e.mapping.map(l.before()), h);
    }
    i && ct(t, r.extensionManager.splittableMarks), e.scrollIntoView();
  }
  return !0;
}, Kr = (i) => ({ tr: e, state: t, dispatch: n, editor: r }) => {
  var s;
  const o = M(i, t.schema), { $from: l, $to: a } = t.selection, c = t.selection.node;
  if (c && c.isBlock || l.depth < 2 || !l.sameParent(a))
    return !1;
  const f = l.node(-1);
  if (f.type !== o)
    return !1;
  const u = r.extensionManager.attributes;
  if (l.parent.content.size === 0 && l.node(-1).childCount === l.indexAfter(-1)) {
    if (l.depth === 2 || l.node(-3).type !== o || l.index(-2) !== l.node(-2).childCount - 1)
      return !1;
    if (n) {
      let w = g.empty;
      const S = l.index(-1) ? 1 : l.index(-2) ? 2 : 3;
      for (let G = l.depth - S; G >= l.depth - 3; G -= 1)
        w = g.from(l.node(G).copy(w));
      const le = l.indexAfter(-1) < l.node(-2).childCount ? 1 : l.indexAfter(-2) < l.node(-3).childCount ? 2 : 3, je = me(u, l.node().type.name, l.node().attrs), be = ((s = o.contentMatch.defaultType) === null || s === void 0 ? void 0 : s.createAndFill(je)) || void 0;
      w = w.append(g.from(o.createAndFill(null, be) || void 0));
      const He = l.before(l.depth - (S - 1));
      e.replace(He, l.after(-le), new y(w, 4 - S, 0));
      let ae = -1;
      e.doc.nodesBetween(He, e.doc.content.size, (G, _t) => {
        if (ae > -1)
          return !1;
        G.isTextblock && G.content.size === 0 && (ae = _t + 1);
      }), ae > -1 && e.setSelection(v.near(e.doc.resolve(ae))), e.scrollIntoView();
    }
    return !0;
  }
  const h = a.pos === l.end() ? f.contentMatchAt(0).defaultType : null, d = me(u, f.type.name, f.attrs), m = me(u, l.node().type.name, l.node().attrs);
  e.delete(l.pos, a.pos);
  const p = h ? [{ type: o, attrs: d }, { type: h, attrs: m }] : [{ type: o, attrs: d }];
  return pe(e.doc, l.pos, 2) ? (n && e.split(l.pos, 2, p).scrollIntoView(), !0) : !1;
};
function Gr(i, e) {
  for (let t = i.depth; t > 0; t -= 1) {
    const n = i.node(t);
    if (e(n))
      return {
        pos: t > 0 ? i.before(t) : 0,
        start: i.start(t),
        depth: t,
        node: n
      };
  }
}
function Ke(i) {
  return (e) => Gr(e.$from, i);
}
function ft(i, e) {
  const { nodeExtensions: t } = Kn(e), n = t.find((o) => o.name === i);
  if (!n)
    return !1;
  const r = {
    name: n.name,
    options: n.options,
    storage: n.storage
  }, s = z(I(n, "group", r));
  return typeof s != "string" ? !1 : s.split(" ").includes("list");
}
const ut = (i, e) => {
  const t = Ke((o) => o.type === e)(i.selection);
  if (!t)
    return !0;
  const n = i.doc.resolve(Math.max(0, t.pos - 1)).before(t.depth);
  if (n === void 0)
    return !0;
  const r = i.doc.nodeAt(n);
  return t.node.type === (r == null ? void 0 : r.type) && Lt(i.doc, t.pos) && i.join(t.pos), !0;
}, ht = (i, e) => {
  const t = Ke((o) => o.type === e)(i.selection);
  if (!t)
    return !0;
  const n = i.doc.resolve(t.start).after(t.depth);
  if (n === void 0)
    return !0;
  const r = i.doc.nodeAt(n);
  return t.node.type === (r == null ? void 0 : r.type) && Lt(i.doc, n) && i.join(n), !0;
}, jr = (i, e) => ({ editor: t, tr: n, state: r, dispatch: s, chain: o, commands: l, can: a }) => {
  const { extensions: c } = t.extensionManager, f = M(i, r.schema), u = M(e, r.schema), { selection: h } = r, { $from: d, $to: m } = h, p = d.blockRange(m);
  if (!p)
    return !1;
  const w = Ke((S) => ft(S.type.name, c))(h);
  if (p.depth >= 1 && w && p.depth - w.depth <= 1) {
    if (w.node.type === f)
      return l.liftListItem(u);
    if (ft(w.node.type.name, c) && f.validContent(w.node.content) && s)
      return o().command(() => (n.setNodeMarkup(w.pos, f), !0)).command(() => ut(n, f)).command(() => ht(n, f)).run();
  }
  return o().command(() => a().wrapInList(f) ? !0 : l.clearNodes()).wrapInList(f).command(() => ut(n, f)).command(() => ht(n, f)).run();
};
function Hr(i, e, t = {}) {
  const { empty: n, ranges: r } = i.selection, s = e ? J(e, i.schema) : null;
  if (n)
    return !!(i.storedMarks || i.selection.$from.marks()).filter((u) => s ? s.name === u.type.name : !0).find((u) => ke(u.attrs, t, { strict: !1 }));
  let o = 0;
  const l = [];
  if (r.forEach(({ $from: u, $to: h }) => {
    const d = u.pos, m = h.pos;
    i.doc.nodesBetween(d, m, (p, w) => {
      if (!p.isText && !p.marks.length)
        return;
      const S = Math.max(d, w), le = Math.min(m, w + p.nodeSize);
      o += le - S, l.push(...p.marks.map((be) => ({
        mark: be,
        from: S,
        to: le
      })));
    });
  }), o === 0)
    return !1;
  const a = l.filter((u) => s ? s.name === u.mark.type.name : !0).filter((u) => ke(u.mark.attrs, t, { strict: !1 })).reduce((u, h) => u + h.to - h.from, 0), c = l.filter((u) => s ? u.mark.type !== s && u.mark.type.excludes(s) : !0).reduce((u, h) => u + h.to - h.from, 0);
  return (a > 0 ? a + c : a) >= o;
}
const Ur = (i, e = {}, t = {}) => ({ state: n, commands: r }) => {
  const { extendEmptyMarkRange: s = !1 } = t, o = J(i, n.schema);
  return Hr(n, o, e) ? r.unsetMark(o, { extendEmptyMarkRange: s }) : r.setMark(o, e);
}, Qr = (i, e, t = {}) => ({ state: n, commands: r }) => {
  const s = M(i, n.schema), o = M(e, n.schema);
  return qe(n, s, t) ? r.setNode(o) : r.setNode(s, t);
}, Xr = (i, e = {}) => ({ state: t, commands: n }) => {
  const r = M(i, t.schema);
  return qe(t, r, e) ? n.lift(r) : n.wrapIn(r, e);
}, Yr = () => ({ state: i, dispatch: e }) => {
  const t = i.plugins;
  for (let n = 0; n < t.length; n += 1) {
    const r = t[n];
    let s;
    if (r.spec.isInputRules && (s = r.getState(i))) {
      if (e) {
        const o = i.tr, l = s.transform;
        for (let a = l.steps.length - 1; a >= 0; a -= 1)
          o.step(l.steps[a].invert(l.docs[a]));
        if (s.text) {
          const a = o.doc.resolve(s.from).marks();
          o.replaceWith(s.from, s.to, i.schema.text(s.text, a));
        } else
          o.delete(s.from, s.to);
      }
      return !0;
    }
  }
  return !1;
}, Zr = () => ({ tr: i, dispatch: e }) => {
  const { selection: t } = i, { empty: n, ranges: r } = t;
  return n || e && r.forEach((s) => {
    i.removeMark(s.$from.pos, s.$to.pos);
  }), !0;
}, _r = (i, e = {}) => ({ tr: t, state: n, dispatch: r }) => {
  var s;
  const { extendEmptyMarkRange: o = !1 } = e, { selection: l } = t, a = J(i, n.schema), { $from: c, empty: f, ranges: u } = l;
  if (!r)
    return !0;
  if (f && o) {
    let { from: h, to: d } = l;
    const m = (s = c.marks().find((w) => w.type === a)) === null || s === void 0 ? void 0 : s.attrs, p = Ut(c, a, m);
    p && (h = p.from, d = p.to), t.removeMark(h, d, a);
  } else
    u.forEach((h) => {
      t.removeMark(h.$from.pos, h.$to.pos, a);
    });
  return t.removeStoredMark(a), !0;
}, ei = (i, e = {}) => ({ tr: t, state: n, dispatch: r }) => {
  let s = null, o = null;
  const l = Xt(typeof i == "string" ? i : i.name, n.schema);
  return l ? (l === "node" && (s = M(i, n.schema)), l === "mark" && (o = J(i, n.schema)), r && t.selection.ranges.forEach((a) => {
    const c = a.$from.pos, f = a.$to.pos;
    n.doc.nodesBetween(c, f, (u, h) => {
      s && s === u.type && t.setNodeMarkup(h, void 0, {
        ...u.attrs,
        ...e
      }), o && u.marks.length && u.marks.forEach((d) => {
        if (o === d.type) {
          const m = Math.max(h, c), p = Math.min(h + u.nodeSize, f);
          t.addMark(m, p, o.create({
            ...d.attrs,
            ...e
          }));
        }
      });
    });
  }), !0) : !1;
}, ti = (i, e = {}) => ({ state: t, dispatch: n }) => {
  const r = M(i, t.schema);
  return $n(r, e)(t, n);
}, ni = (i, e = {}) => ({ state: t, dispatch: n }) => {
  const r = M(i, t.schema);
  return Pn(r, e)(t, n);
};
var ri = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  blur: Xn,
  clearContent: Yn,
  clearNodes: Zn,
  command: _n,
  createParagraphNear: er,
  deleteNode: tr,
  deleteRange: nr,
  deleteSelection: rr,
  enter: ir,
  exitCode: sr,
  extendMarkRange: lr,
  first: ar,
  focus: ur,
  forEach: hr,
  insertContent: dr,
  insertContentAt: gr,
  joinBackward: yr,
  joinForward: wr,
  keyboardShortcut: Sr,
  lift: xr,
  liftEmptyBlock: vr,
  liftListItem: br,
  newlineInCode: Mr,
  resetAttributes: Cr,
  scrollIntoView: Ir,
  selectAll: Er,
  selectNodeBackward: Tr,
  selectNodeForward: Or,
  selectParentNode: Nr,
  selectTextblockEnd: Ar,
  selectTextblockStart: Rr,
  setContent: Fr,
  setMark: $r,
  setMeta: Pr,
  setNode: Jr,
  setNodeSelection: Dr,
  setTextSelection: Lr,
  sinkListItem: Wr,
  splitBlock: qr,
  splitListItem: Kr,
  toggleList: jr,
  toggleMark: Ur,
  toggleNode: Qr,
  toggleWrap: Xr,
  undoInputRule: Yr,
  unsetAllMarks: Zr,
  unsetMark: _r,
  updateAttributes: ei,
  wrapIn: ti,
  wrapInList: ni
});
B.create({
  name: "commands",
  addCommands() {
    return {
      ...ri
    };
  }
});
B.create({
  name: "editable",
  addProseMirrorPlugins() {
    return [
      new se({
        key: new oe("editable"),
        props: {
          editable: () => this.editor.options.editable
        }
      })
    ];
  }
});
B.create({
  name: "focusEvents",
  addProseMirrorPlugins() {
    const { editor: i } = this;
    return [
      new se({
        key: new oe("focusEvents"),
        props: {
          handleDOMEvents: {
            focus: (e, t) => {
              i.isFocused = !0;
              const n = i.state.tr.setMeta("focus", { event: t }).setMeta("addToHistory", !1);
              return e.dispatch(n), !1;
            },
            blur: (e, t) => {
              i.isFocused = !1;
              const n = i.state.tr.setMeta("blur", { event: t }).setMeta("addToHistory", !1);
              return e.dispatch(n), !1;
            }
          }
        }
      })
    ];
  }
});
B.create({
  name: "keymap",
  addKeyboardShortcuts() {
    const i = () => this.editor.commands.first(({ commands: o }) => [
      () => o.undoInputRule(),
      () => o.command(({ tr: l }) => {
        const { selection: a, doc: c } = l, { empty: f, $anchor: u } = a, { pos: h, parent: d } = u, m = k.atStart(c).from === h;
        return !f || !m || !d.type.isTextblock || d.textContent.length ? !1 : o.clearNodes();
      }),
      () => o.deleteSelection(),
      () => o.joinBackward(),
      () => o.selectNodeBackward()
    ]), e = () => this.editor.commands.first(({ commands: o }) => [
      () => o.deleteSelection(),
      () => o.joinForward(),
      () => o.selectNodeForward()
    ]), n = {
      Enter: () => this.editor.commands.first(({ commands: o }) => [
        () => o.newlineInCode(),
        () => o.createParagraphNear(),
        () => o.liftEmptyBlock(),
        () => o.splitBlock()
      ]),
      "Mod-Enter": () => this.editor.commands.exitCode(),
      Backspace: i,
      "Mod-Backspace": i,
      "Shift-Backspace": i,
      Delete: e,
      "Mod-Delete": e,
      "Mod-a": () => this.editor.commands.selectAll()
    }, r = {
      ...n
    }, s = {
      ...n,
      "Ctrl-h": i,
      "Alt-Backspace": i,
      "Ctrl-d": e,
      "Ctrl-Alt-Backspace": e,
      "Alt-Delete": e,
      "Alt-d": e,
      "Ctrl-a": () => this.editor.commands.selectTextblockStart(),
      "Ctrl-e": () => this.editor.commands.selectTextblockEnd()
    };
    return Ve() || Qt() ? s : r;
  },
  addProseMirrorPlugins() {
    return [
      new se({
        key: new oe("clearDocument"),
        appendTransaction: (i, e, t) => {
          if (!(i.some((m) => m.docChanged) && !e.doc.eq(t.doc)))
            return;
          const { empty: r, from: s, to: o } = e.selection, l = k.atStart(e.doc).from, a = k.atEnd(e.doc).to, c = s === l && o === a, f = t.doc.textBetween(0, t.doc.content.size, " ", " ").length === 0;
          if (r || !c || !f)
            return;
          const u = t.tr, h = jt({
            state: t,
            transaction: u
          }), { commands: d } = new qn({
            editor: this.editor,
            state: h
          });
          if (d.clearNodes(), !!u.steps.length)
            return u;
        }
      })
    ];
  }
});
B.create({
  name: "tabindex",
  addProseMirrorPlugins() {
    return [
      new se({
        key: new oe("tabindex"),
        props: {
          attributes: this.editor.isEditable ? { tabindex: "0" } : {}
        }
      })
    ];
  }
});
class re {
  constructor(e = {}) {
    this.type = "node", this.name = "node", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...e
    }, this.name = this.config.name, e.defaultOptions && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = z(I(this, "addOptions", {
      name: this.name
    }))), this.storage = z(I(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(e = {}) {
    return new re(e);
  }
  configure(e = {}) {
    const t = this.extend();
    return t.options = We(this.options, e), t.storage = z(I(t, "addStorage", {
      name: t.name,
      options: t.options
    })), t;
  }
  extend(e = {}) {
    const t = new re(e);
    return t.parent = this, this.child = t, t.name = e.name ? e.name : t.parent.name, e.defaultOptions && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${t.name}".`), t.options = z(I(t, "addOptions", {
      name: t.name
    })), t.storage = z(I(t, "addStorage", {
      name: t.name,
      options: t.options
    })), t;
  }
}
const _ = re.create({
  name: "column",
  group: "column",
  content: "(paragraph|block)*",
  isolating: !0,
  selectable: !1,
  renderHTML({ HTMLAttributes: i }) {
    const e = Ht(i, { class: "column" });
    return ["div", e, 0];
  }
}), ii = (i, e) => Array.from({ length: i }, (t, n) => e(n)), Ge = ({ type: i, content: e }) => e ? { type: i, content: e } : { type: i }, si = ({ content: i }) => Ge({ type: "paragraph", content: i }), Yt = ({ content: i }) => Ge({ type: "column", content: i }), dt = ({ content: i }) => Ge({ type: "columnBlock", content: i }), pt = (i) => {
  const e = [si({})];
  return ii(i, () => Yt({ content: e }));
}, Pe = (i, e) => {
  for (let t = i.depth; t > 0; t--) {
    const n = i.node(t), r = t > 0 ? i.before(t) : 0, s = i.start(t);
    if (e({ node: n, pos: r, start: s }))
      return {
        start: s,
        depth: t,
        node: n,
        pos: r
      };
  }
  throw Error("no ancestor found");
};
class xe extends k {
  constructor(e) {
    const { $from: t, $to: n } = e;
    super(t, n), this._$from = t, this._$to = n;
  }
  get $from() {
    return this._$from;
  }
  get $to() {
    return this._$to;
  }
  map() {
    return this;
  }
  content() {
    return this.$from.doc.slice(this.from, this.to, !0);
  }
  eq(e) {
    return e instanceof xe && e.anchor == this.anchor;
  }
  toJSON() {
    return { type: "column", from: this.from, to: this.to };
  }
  expandSelection(e) {
    var l;
    const t = ({ pos: a, node: c }) => c.type.name === _.name ? !0 : e.resolve(a).depth <= 0, { pos: n } = Pe(this.$from, t);
    this._$from = e.resolve(n);
    const { pos: r, node: s } = Pe(this.$to, t);
    this._$to = e.resolve(r + s.nodeSize), ((l = this.getFirstNode()) == null ? void 0 : l.type.name) === Zt.name && (this._$from = e.resolve(this.$from.pos + 2), this._$to = e.resolve(this.$to.pos + 2));
    const o = this;
    o.$anchor = this._$from, o.$head = this._$to, o.ranges = [new Rt(this._$from, this._$to)];
  }
  static create(e, t, n) {
    const r = e.resolve(t), s = e.resolve(n), o = new v(r, s);
    return new xe(o);
  }
  getFirstNode() {
    return this.content().content.firstChild;
  }
}
const Zt = re.create({
  name: "columnBlock",
  group: "block",
  content: "column{2,}",
  isolating: !0,
  selectable: !0,
  addOptions() {
    return {
      nestedColumns: !1,
      columnType: _
    };
  },
  renderHTML({ HTMLAttributes: i }) {
    const e = Ht(i, { class: "column-block" });
    return ["div", e, 0];
  },
  addCommands() {
    return {
      unsetColumns: () => ({ tr: t, dispatch: n }) => {
        try {
          if (!n)
            return;
          const r = t.selection.$from, o = Pe(r, ({ node: f }) => !this.options.nestedColumns && f.type == this.type ? !0 : f.type == this.type);
          if (o === void 0)
            return;
          let l = [];
          o.node.descendants((f, u, h) => {
            (h == null ? void 0 : h.type.name) === _.name && l.push(f);
          }), l = l.reverse().filter((f) => f.content.size > 0);
          const a = t.doc.resolve(o.pos), c = new x(a);
          return t = t.setSelection(c), l.forEach((f) => t = t.insert(o.pos, f)), t = t.deleteSelection(), n(t);
        } catch (r) {
          console.error(r);
        }
      },
      setColumns: (t, n = !1) => ({ tr: r, dispatch: s }) => {
        try {
          const { doc: o, selection: l } = r;
          if (!s) {
            console.log("no dispatch");
            return;
          }
          const a = new xe(l);
          a.expandSelection(o);
          const { openStart: c, openEnd: f } = a.content();
          if (c !== f) {
            console.warn("failed depth check");
            return;
          }
          let u;
          if (n) {
            const p = a.content().toJSON(), w = Yt(p), S = pt(t - 1);
            u = dt({
              content: [w, ...S]
            });
          } else {
            const p = pt(t);
            u = dt({ content: p });
          }
          const h = o.type.schema.nodeFromJSON(u);
          if (h === null)
            return;
          const d = a.$anchor.parent.type;
          if (!((p) => !(!p.contentMatch.matchType(this.type) || !this.options.nestedColumns && p.name === _.name))(d)) {
            console.warn("content not allowed");
            return;
          }
          return r = r.setSelection(a), r = r.replaceSelectionWith(h, !1), s(r);
        } catch (o) {
          console.error(o);
        }
      }
    };
  }
}), oi = B.create({
  name: "columnExtension",
  addExtensions() {
    const i = [];
    return this.options.column !== !1 && i.push(_), this.options.columnBlock !== !1 && i.push(Zt), i;
  }
});
export {
  _ as Column,
  Zt as ColumnBlock,
  oi as ColumnExtension,
  oi as default
};
